/*! TechSmithRenderLibJS - v0.23.5 - 2016-01-28 */(function (window) {
   "use strict";

   /**
    * tscrl JavaScript namespace.
    * @namespace tscrl
    */
   window.tscrl = window.tscrl || {};

})(this);
(function (window, stringHelperFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.stringHelper = stringHelperFactory();

})(this, function () {
   "use strict";
   var isAbsoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');

   var isAbsoluteUrl = function(url){
      return isAbsoluteUrlRegex.test(url);
   };

   /**
    * @memberof tscrl
    * @class stringHelper
    * @static
    * @classdesc String utility methods, like Uri parsing
    */
   return {
      /**
       *  Tests whether or not the given URL is an absolute URL
       *  @memberof tscrl.stringHelper
       *  @static
       *  @function isAbsoluteUrl
       *  @param {String} url - url to be tested
       *  @return {Boolean} whether or not url is a valid absolute url
       */
      isAbsoluteUrl: isAbsoluteUrl
   };
});

(function (window, constantsFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.constants = constantsFactory();
})(this, function () {
   "use strict";

   return Object.freeze({
      /**
       *  Constants that define the various types of SceneViews.
       *  @constant DEFAULT_VOLUME
       *  @static
       */
      DEFAULT_VOLUME: 1.0,
      /**
       *  Constants that define the various types of SceneViews.
       *  @constant SCENEVIEW_TYPE
       *  @static
       */
      SCENE_VIEW_TYPE: Object.freeze({
         CONTENT: "content",
         THEMEABLE: "themeable"
      }),
      /**
       *  Constants that define the various types of SourceViews.
       *  @constant SOURCE_VIEW_TYPE
       *  @static
       */
      SOURCE_VIEW_TYPE: Object.freeze({
         IMAGE: "image",
         VIDEO: "video",
         EMPTY: "",
         AUDIO: "audio",
         ERROR: "error"
      }),
      /**
       * Constants that define rotation class for SourceViews.
       */
      SOURCE_VIEW_ROTATE: Object.freeze({
         "0": "tscrl-rotate0",
         "90": "tscrl-rotate90",
         "180": "tscrl-rotate180",
         "270": "tscrl-rotate270"
      }),
      /**
       *  Mime type for an emepty source.
       *  @constant EMPTY_SOURCE_MIMETYPE
       *  @static
       */
      EMPTY_SOURCE_MIMETYPE: "techsmith/emptysource",
      /**
       *  Class to add to source view container element.
       *  @constant SOURCE_CLASS_NAME
       *  @static
       */
      SOURCE_CLASS_NAME: "tscrl-source",
      /**
       *  Class to add to scene view container element.
       *  @constant SCENE_CLASS_NAME
       *  @static
       */
      SCENE_CLASS_NAME: "tscrl-scene",
      /**
       *  Media Events to track on a media element.
       *  @constant MEDIA_EVENTS
       *  @static
       */
      MEDIA_EVENTS: ["canplay", "canplaythrough", "timeupdate", "ended", "seeking", "seeked", "play", "playing", "pause"],
      /**
       *  Max length for text input
       *  @constant TEXT_INPUT_MAX_LENGTH
       *  @static
       */
      TEXT_INPUT_MAX_LENGTH: 40,
      /**
       *  Title input placeholder text.
       *  @constant TEXT_INPUT_MAX_LENGTH
       *  @static
       */
      TITLE_TITLE_PLACEHOLDER_TEXT: "Enter title...",
      /**
       *  Default font name for the text used in themes.
       *  @constant DEFAULT_THEME_TEXT_FONT_NAME
       *  @static
       */
      DEFAULT_THEME_TEXT_FONT_NAME: "Lato",
      /**
       *  Default size for the Font used in themes.
       *  @constant DEFAULT_THEME_TEXT_FONT_SIZE
       *  @static
       */
      DEFAULT_THEME_TEXT_FONT_SIZE: "54*scale",
      /**
       *  Default weight for the Font used in themes.
       *  @constant DEFAULT_THEME_TEXT_FONT_WEIGHT
       *  @static
       */
      DEFAULT_THEME_TEXT_FONT_WEIGHT: "Normal",
      /**
       *  Default value for each color component for the Font in themes.
       *  @constant DEFAULT_THEME_TEXT_FONT_COLOR_COMPONENT
       *  @static
       */
      DEFAULT_THEME_TEXT_FONT_COLOR_COMPONENT: 0,
      /**
       *  Default value for horizontal alignment of theme text
       *  @constant DEFAULT_THEME_TEXT_HORIZ_ALIGN
       *  @static
       */
      DEFAULT_THEME_TEXT_HORIZ_ALIGN: "center",
      /**
       *  Default value for vertical alignment of theme text
       *  @constant DEFAULT_THEME_TEXT_VERT_ALIGN
       *  @static
       */
      DEFAULT_THEME_TEXT_VERT_ALIGN: "middle",
      /**
       *  Default value for the playback rate
       *  @constant DEFAULT_PLAYBACK_RATE
       *  @static
       */
      DEFAULT_PLAYBACK_RATE: 1
   });
});


(function (window) {
   'use strict';

   var namespace = window.tscrl = window.tscrl || {};
   var attachEvent = document.attachEvent,
      stylesCreated = false;

   if (!attachEvent) {
      var requestFrame = (function () {
         var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
            function (fn) {
               return window.setTimeout(fn, 20);
            };
         return function (fn) {
            return raf(fn);
         };
      })();

      var cancelFrame = (function () {
         var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
            window.clearTimeout;
         return function (id) {
            return cancel(id);
         };
      })();

      var resetTriggers = function (element) {
         var triggers = element.__resizeTriggers__,
            expand = triggers.firstElementChild,
            contract = triggers.lastElementChild,
            expandChild = expand.firstElementChild;
         contract.scrollLeft = contract.scrollWidth;
         contract.scrollTop = contract.scrollHeight;
         expandChild.style.width = expand.offsetWidth + 1 + 'px';
         expandChild.style.height = expand.offsetHeight + 1 + 'px';
         expand.scrollLeft = expand.scrollWidth;
         expand.scrollTop = expand.scrollHeight;
      };

      var checkTriggers = function (element) {
         return element.offsetWidth != element.__resizeLast__.width ||
            element.offsetHeight != element.__resizeLast__.height;
      };

      var scrollListener = function (e) {
         /* jshint validthis: true */
         var element = this;
         resetTriggers(this);
         if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
         this.__resizeRAF__ = requestFrame(function () {
            if (checkTriggers(element)) {
               element.__resizeLast__.width = element.offsetWidth;
               element.__resizeLast__.height = element.offsetHeight;
               element.__resizeListeners__.forEach(function (fn) {
                  fn.call(element, e);
               });
            }
         });
      };

      /* Detect CSS Animations support to detect element display/re-attach */
      var animation = false,
         animationstring = 'animation',
         keyframeprefix = '',
         animationstartevent = 'animationstart',
         domPrefixes = 'Webkit Moz O ms'.split(' '),
         startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
         pfx = '';
      {
         var elm = window.document.createElement('fakeelement');
         if (elm.style.animationName !== undefined) {
            animation = true;
         }

         if (animation === false) {
            for (var i = 0; i < domPrefixes.length; i++) {
               if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                  pfx = domPrefixes[i];
                  animationstring = pfx + 'Animation';
                  keyframeprefix = '-' + pfx.toLowerCase() + '-';
                  animationstartevent = startEvents[i];
                  animation = true;
                  break;
               }
            }
         }
      }

      var animationName = 'resizeanim';
      var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
      var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
   }

   function createStyles() {
      if (!stylesCreated) {
         //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
         var css = (animationKeyframes ? animationKeyframes : '') +
               '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
               '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
            head = window.document.head || window.document.getElementsByTagName('head')[0],
            style = window.document.createElement('style');

         style.type = 'text/css';
         if (style.styleSheet) {
            style.styleSheet.cssText = css;
         } else {
            style.appendChild(window.document.createTextNode(css));
         }

         head.appendChild(style);
         stylesCreated = true;
      }
   }

   namespace.addResizeListener = function (element, fn) {
      if (attachEvent) element.attachEvent('onresize', fn);
      else {
         if (!element.__resizeTriggers__) {
            if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
            createStyles();
            element.__resizeLast__ = {};
            element.__resizeListeners__ = [];
            (element.__resizeTriggers__ = window.document.createElement('div')).className = 'resize-triggers';
            element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
            '<div class="contract-trigger"></div>';
            element.appendChild(element.__resizeTriggers__);
            resetTriggers(element);
            element.addEventListener('scroll', scrollListener, true);

            /* Listen for a css animation to detect element display/re-attach */
            if (animationstartevent) {
               element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
                  if (e.animationName == animationName) {
                     resetTriggers(element);
                  }
               });
            }
         }
         element.__resizeListeners__.push(fn);
      }
   };

   namespace.removeResizeListener = function (element, fn) {
      if (attachEvent) element.detachEvent('onresize', fn);
      else {
         element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
         if (!element.__resizeListeners__.length) {
            element.removeEventListener('scroll', scrollListener);
            element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
         }
      }
   };
})(this);

(function (window, mediaListTimeRangesFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.MediaListTimeRanges = mediaListTimeRangesFactory(window);

})(this, function (window) {

   "use strict";

   /**
    * @memberof tscrl
    * @class MediaListTimeRanges
    * @param {Array.<tscrl.SceneView>} sceneViewList - List of scene views.
    * @param {String} timeRangesName - Name of the media element TimeRanges to watch.
    * @classdesc TimeRanges api implemented for a list of media elements.
    */
   var MediaListTimeRanges = function (sceneViewList, timeRangesName) {
      var _public;

      if (timeRangesName !== "buffered" && timeRangesName !== "seekable") {
         throw new Error("MediaListTimeRanges timeRangesName (" + timeRangesName + ") is invalid, must be 'buffered' or 'seekable'");
      }

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.MediaListTimeRanges
          *  @property {Number} length - Number of TimeRanges across all media in the list.
          */
         length: {
            get: function () {
               var bufferedLength = 0;
               sceneViewList.forEach(function (sceneView) {
                  bufferedLength += (sceneView.mediaElement !== null && sceneView.mediaElement[timeRangesName]) ? sceneView.mediaElement[timeRangesName].length : 0;
               });
               return bufferedLength;
            }
         }
      });

      /**
       *  Add media information to the list.
       *  @function addMedia
       *  @param {tscrl.SceneView} sceneView - Scene view
       *  @param {Number} index - Optional index to place information into list.  If not supplied it will be appended.
       *  @memberof tscrl.MediaListTimeRanges
       */
      _public.addMedia = function (sceneView, index) {
         if (!isNaN(parseInt(index, 10)) && index !== sceneViewList.length) {
            if (index < 0 || index > sceneViewList.length) {
               throw(new Error("MediaListTimeRanges.addMedia().  Index (" + index + ") is out of range."));
            }
            sceneViewList.splice(index, 0, sceneView);
         } else {
            sceneViewList.push(sceneView);
         }
      };

      /**
       *  Remove media information to the list.
       *  @function removeMedia
       *  @param {Number} index - index of media to remove from list.
       *  @memberof tscrl.MediaListTimeRanges
       */
      _public.removeMedia = function (index) {
         if (index < 0 || index >= sceneViewList.length) {
            throw(new Error("MediaListTimeRanges.removeMedia().  Index (" + index + ") is out of range."));
         }
         sceneViewList.splice(index, 1);
      };

      /**
       *  Move media to location in list.
       *  @function moveMedia
       *  @param {Number} fromIndex - index of media to move.
       *  @param {Number} toIndex - index to move media info to.
       *  @memberof tscrl.MediaListTimeRanges
       */
      _public.moveMedia = function (fromIndex, toIndex) {
         if (fromIndex < 0 || fromIndex >= sceneViewList.length) {
            throw(new Error("MediaListTimeRanges.moveMedia().  fromIndex (" + fromIndex + ") is out of range."));
         }
         if (toIndex < 0 || toIndex >= sceneViewList.length) {
            throw(new Error("MediaListTimeRanges.moveMedia().  toIndex (" + toIndex + ") is out of range."));
         }
         sceneViewList.splice(toIndex, 0, sceneViewList.splice(fromIndex, 1)[0]);
      };

      /**
       *  Query the start value for the time range object in context to the entire media list.
       *  @function start
       *  @param {Number} index - Index of the time range to query.
       *  @memberof tscrl.MediaListTimeRanges
       *  @return {Number} start value of the specified time range.
       */
      _public.start = function (index) {
         var absoluteDuration = 0,
            totalBufferedRanges = 0,
            relativeStartIndex;

         for (var i = 0; i < sceneViewList.length; i++) {
            if(sceneViewList[i].mediaElement === null) {
               continue;
            }
            totalBufferedRanges += sceneViewList[i].mediaElement[timeRangesName] ? sceneViewList[i].mediaElement[timeRangesName].length : 0;
            if (index < totalBufferedRanges) {
               relativeStartIndex = (totalBufferedRanges - 1) - index;
               return absoluteDuration + sceneViewList[i].mediaElement[timeRangesName].start(relativeStartIndex);
            }
            absoluteDuration += sceneViewList[i].duration;
         }
         throw new Error("Failed to execute 'start' on 'MediaListTimeRanges': The index provided (" + index + ") is greater than the maximum bound (" + totalBufferedRanges + ").");
      };

      /**
       *  Query the end value for the time range object in context to the entire media list.
       *  @function end
       *  @param {Number} index - Index of the time range to query.
       *  @memberof tscrl.MediaListTimeRanges
       *  @return {Number} end value of the specified time range.
       */
      _public.end = function (index) {
         var absoluteDuration = 0,
            totalBufferedRanges = 0,
            relativeEndIndex;

         for (var i = 0; i < sceneViewList.length; i++) {
            if(sceneViewList[i].mediaElement === null) {
               continue;
            }
            totalBufferedRanges += sceneViewList[i].mediaElement[timeRangesName] ? sceneViewList[i].mediaElement[timeRangesName].length : 0;
            if (index < totalBufferedRanges) {
               relativeEndIndex = (totalBufferedRanges - 1) - index;
               return absoluteDuration + sceneViewList[i].mediaElement[timeRangesName].end(relativeEndIndex);
            }
            absoluteDuration += sceneViewList[i].duration;
         }
         throw new Error("Failed to execute 'end' on 'MediaListTimeRanges': The index provided (" + index + ") is greater than the maximum bound (" + totalBufferedRanges + ").");
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new MediaListTimeRanges object.
       *  @function create
       *  @param {Array.<tscrl.SceneView>} sceneList - List of media data.
       *  @param {String} timeRangesName - Name of the media element TimeRanges to watch.
       *  @memberof tscrl.MediaListTimeRanges
       *  @static
       *  @return new MediaListTimeRanges instance
       */
      create: function (sceneList, timeRangesName) {
         return new MediaListTimeRanges(sceneList, timeRangesName);
      }
   };
});

(function (window, eventDispatcherFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.EventDispatcher = eventDispatcherFactory(window);

})(this, function (window) {

   "use strict";

   /**
    * @memberof tscrl
    * @class EventDispatcher
    * @classdesc Add and notify of events.
    */
   var EventDispatcher = function () {

      var _events = {};

      var notifyListeners = function (eventEntry, data) {
         eventEntry.forEach(function (event) {
            event(data);
         });
      };

      return {
         /**
          *  Add a callback function for an event.
          *  @memberof tscrl.EventDispatcher
          *  @function on
          *  @param {String} eventName - Name of event to listen for.
          *  @param {Function} callback - Callback function for event.
          */
         on: function (eventName, callback) {
            if (typeof eventName != "string" || typeof callback != "function") {
               throw new Error("EventDispatcher.on expects string for the eventName and a callback function.");
            }
            if (!_events[eventName]) {
               _events[eventName] = [];
            }
            _events[eventName].push(callback);
         },
         /**
          *  Remove a callback function for an event.
          *  @memberof tscrl.EventDispatcher
          *  @function off
          *  @param {String} eventName - Name of event to listen for.
          *  @param {Function} callback - Callback function for event.
          */
         off: function (eventName, callback) {
            var eventEntry = _events[eventName];
            if (eventEntry) {
               for (var i = 0; i < eventEntry.length; i++) {
                  if (eventEntry[i] === callback) {
                     eventEntry.splice(i, 1);
                     break;
                  }
               }
               if (eventEntry.length === 0) {
                  _events[eventName] = undefined;
               }
            }
         },
         /**
          *  Trigger the event.
          *  @memberof tscrl.EventDispatcher
          *  @function trigger
          *  @param {String} eventName - Name of event to trigger.
          *  @param {Object} data - Event data.
          */
         trigger: function (eventName, data) {
            data = data || {};
            if (typeof eventName != "string") {
               throw new Error("EventDispatcher.trigger expects string for the eventName.");
            }

            if (_events[eventName]) {
               data.type = eventName;
               notifyListeners(_events[eventName], data);
            }
         }
      };
   };

   return {
      /**
       *  Factory method that returns a new EventDispatcher object.
       *  @function create
       *  @memberof tscrl.EventDispatcher
       *  @static
       *  @return {tscrl.EventDispatcher} new EventDispatcher instance
       */
      create: function () {
         return new EventDispatcher();
      }
   };
});

(function (window, themeWrapperFactory) {
   "use strict";
   var namespace = window.tscrl = window.tscrl || {};
   namespace.ThemeWrapper = themeWrapperFactory(namespace.EventDispatcher);
})(this, function (EventDispatcher) {
   "use strict";

   var eventEnum =
   {
      THEME_UPDATED: "themeUpdated"
   };

   /**
    * @memberof tscrl
    * @class tscrl.ThemeWrapper
    * @param {object} theme - a tscml Theme object
    * @classdesc An interface to read properties from themes and listen to theme events
    */
   var ThemeWrapper = function (themeObj) {

      var _theme,
         _eventDispatcher;

      _theme = themeObj;
      _eventDispatcher = EventDispatcher.create();


      var _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @memberof tscrl.ThemeWrapper
          *  @property {Object} theme - The theme that is applied to the entire project..
          */
         theme: {
            get: function () {
               return _theme;
            },
            set: function (value) {
               _theme = value;
               _eventDispatcher.trigger(eventEnum.THEME_UPDATED, this);
            }
         }
      });


      /**
       *  Observe an event on this object
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ThemeWrapper
       */
      _public.on = function (eventName, callback) {
         _eventDispatcher.on(eventName, callback);
      };

      /**
       *  Stop observing an event on this object
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ThemeWrapper
       */
      _public.off = function (eventName, callback) {
         _eventDispatcher.off(eventName, callback);
      };

      /**
       * Retrieves a section of the theme file that corresponds to this theme tag
       * @function getThemeForTag
       * @param {String} themeTag - the theme tag to look up
       * @returns {Object} a section of the theme file that corresponds to this theme tag
       * @memberof tscrl.ThemeWrapper
       */
      _public.getThemeForTag = function (themeTag) {
         if (typeof _theme === "undefined" || _theme.themeTags === undefined) {
            return null;
         }

         var themeTagObj = _theme.themeTags[themeTag];
         if (typeof themeTagObj !== "undefined") {
            return themeTagObj;
         }
         return null;
      };

      return _public;
   };

   return {

      /**
       * An enumeration of all the events this object can fire
       * @enum events
       * @memberof tscrl.ThemeWrapper
       */
      events: eventEnum,

      /**
       *  Factory method that returns a new ThemeWrapper object.
       *  @function create
       *  @memberof tscrl.ThemeWrapper
       *  @param {object} theme - a tscml Theme object
       *  @static
       *  @return {tscrl.ThemeWrapper} new ThemeWrapper instance.
       */
      create: function (theme) {
         return new ThemeWrapper(theme);
      }
   };
});

(function (window, transformProviderFactory) {
   "use strict";
   var namespace = window.tscrl = window.tscrl || {};
   namespace.transformProvider = transformProviderFactory();
})(this, function () {
   "use strict";

   var _pixelPerfectRect = {
      width: 1920,
      height: 1080
   };

   var _transformProvider = Object.defineProperties({}, {
      canvasRect: {
         value: Object.freeze(_pixelPerfectRect)
      }
   });

   return _transformProvider;
});


(function (window, uriBuilderFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.UriBuilder = uriBuilderFactory(window, window.Q, namespace.stringHelper);

})(this, function (window, Q, stringHelper) {

   "use strict";

   var _fileResolvers = [];

   /**
    * @memberof tscrl
    * @class UriBuilder
    * @classdesc Helper Class to build a uri from a Media Lib Source object.
    */
   var UriBuilder = function () {
      var _basePath,
         _public;

      _basePath = "";

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @memberof tscrl.UriBuilder
          *  @property {String} basePath - Base path to append to source uri.
          */
         basePath: {
            get: function () {
               return _basePath;
            },
            set: function (value) {
               _basePath = value || "";
            }
         }
      });

      /**
       *  Get the uri for a source object.
       *  @function getUri
       *  @param {Object} source - Media lib source object.
       *  @memberof tscrl.UriBuilder
       *  @return {Object} Q promise.
       */
      _public.getUri = function (source) {
         var canResolvePromises = [];
         _fileResolvers.forEach(function(resolver) {
            canResolvePromises.push(resolver.canResolve(source.uri));
         });

         return Q.allSettled(canResolvePromises).then(function(results){
            for(var i = 0; i < results.length; i++){
               var result = results[i];
               if (result.state === 'fulfilled' && result.value){
                  return _fileResolvers[i].getUri(source.uri);
               }
            }

            return stringHelper.isAbsoluteUrl(source.uri) ? source.uri : (_basePath + source.uri);
         });
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new UriBuilder object.
       *  @function create
       *  @memberof tscrl.UriBuilder
       *  @static
       *  @return {tscrl.UriBuilder} new UriBuilder instance
       */
      create: function () {
         return new UriBuilder();
      },
      /**
       *  Registers a fileResolver by mime-type
       *  @function registerFileResolverForMimeTypes
       *  @memberof tscrl.UriBuilder
       *  @static
       *  @deprecated This method is deprecated. Use tsc.UriBuilder.registerFileResolver
       */
      registerFileResolverForMimeTypes: function (fileResolver, mimeTypeList) {
         throw new Error("UriBuilder.registerFileResolverForMimeTypes is deprecated use registerFileResolver method.");
      },
      /**
       *  Registers a fileResolver
       *  @function registerFileResolver
       *  @memberof tscrl.UriBuilder
       *  @static
       */
      registerFileResolver: function (fileResolver) {
         if (typeof fileResolver !== "object" || typeof fileResolver.getUri !== "function" || typeof fileResolver.canResolve !== "function" || !fileResolver.hasOwnProperty('id')) {
            throw new Error("UriBuilder.registerFileResolverForMimeTypes: fileResolver must have id property and implement a getUri and canResolve methods.");
         }

         _fileResolvers.push(fileResolver);
      },
      /**
       *  Removes all registered fileResolvers
       *  @function removeAllFileResolvers
       *  @memberof tscrl.UriBuilder
       *  @static
       */
      removeAllFileResolvers: function() {
         _fileResolvers = [];
      }
   };
});

(function (window, mediaPlaybackDecoratorFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.MediaPlaybackDecorator = mediaPlaybackDecoratorFactory(window, namespace.EventDispatcher, namespace.constants);

})(this, function (window, EventDispatcher, constants) {
   "use strict";

   /**
    * Theme tag model change event .
    * @event tscrl.MediaPlaybackDecorator#themeTagModelChange
    * @type {object}
    * @property {Object} eventData - Data info passed with event.
    * @property {String} eventData.currentTarget - the html element of the current target
    */

   /**
    * @memberof tscrl
    * @class MediaPlaybackDecorator
    * @param {Element} element - Html element to decorate.
    * @param {tscml.Scene} scene - The corresponding scene for the element being decorated.
    * @classdesc Media Playback Decorator will implement HTMLMediaElement api for time based playback.
    */
   var MediaPlaybackDecorator = function (element, scene) {
      var _currentTime,
         _lastTimeCalled,
         _captureTime,
         _hasStartedPlayback,
         _eventDispatcher;

      _currentTime = 0;
      _hasStartedPlayback = false;
      _captureTime = false;
      _eventDispatcher = EventDispatcher.create();

      var getSceneDuration = function () {
         return scene !== undefined ? scene.duration : 0;
      };

      var dispatchEvent = function(eventName) {
         _eventDispatcher.trigger(eventName, {currentTarget: element});
      };

      var onTimeUpdate = function () {
         dispatchEvent("timeupdate");
         if (_currentTime >= getSceneDuration()) {
            element.ended = true;
            _currentTime = getSceneDuration();
            dispatchEvent("ended");
            _captureTime = false;
         } else {
            element.ended = false;
         }
      };

      var onAnimationFrame = function (timestamp) {
         if (typeof _lastTimeCalled !== "undefined") {
            _currentTime += (element.playbackRate * ((timestamp - _lastTimeCalled) / 1000));
            onTimeUpdate();
         }

         if (_captureTime) {
            _lastTimeCalled = timestamp;
            window.requestAnimationFrame(onAnimationFrame);
         }
      };

      var onPlay = function () {
         if(element.ended === true) {
            element.seekToTime(0);
         }
         element.paused = false;
         startCapturingTime();
         dispatchEvent("play");
      };

      var onPause = function () {
         element.paused = true;
         _captureTime = false;
         dispatchEvent("pause");
      };

      var startCapturingTime = function () {
         _lastTimeCalled = undefined;
         _captureTime = true;
         dispatchEvent("playing");
         window.requestAnimationFrame(onAnimationFrame);
      };

      Object.defineProperties(element, {
         currentTime: {
            get: function () {
               return _currentTime;
            },
            set: function (time) {
               if (isNaN(parseFloat(time))) {
                  throw new Error("Decorated element, expected currentTime to be a Number.");
               }
               if(!_hasStartedPlayback) {
                  dispatchEvent("canplay");
                  dispatchEvent("canplaythrough");
                  _hasStartedPlayback = true;
               }
               _currentTime = time < 0 ? 0 : (time > getSceneDuration() ? getSceneDuration() : time);
               dispatchEvent("seeking");
               onTimeUpdate();
               dispatchEvent("seeked");
            }
         },
         duration: {
            get: function () {
               return getSceneDuration();
            }
         },
         playbackRate: {
            get: function() {
               return this.value;
            },
            set: function(value) {
               this.value = value;
            }
         },
         seekable: {
            get: function () {
               return {
                  length: 1,
                  start: function () {
                     return 0;
                  },
                  end: function () {
                     return getSceneDuration();
                  }
               };
            }
         },
         buffered: {
            get: function () {
               return {
                  length: 1,
                  start: function () {
                     return 0;
                  },
                  end: function () {
                     return getSceneDuration();
                  }
               };
            }
         },
         paused: {
            value: true,
            writable: true
         },
         ended: {
            value: false,
            writable: true
         }
      });

      element.playbackRate = constants.DEFAULT_PLAYBACK_RATE;

      /**
       *  Add event listener to this element.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.MediaPlaybackDecorator
       */
      element.on = _eventDispatcher.on;

      /**
       *  Remove event listener from this element.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.MediaPlaybackDecorator
       */
      element.off = _eventDispatcher.off;

      element.play = onPlay;

      element.pause = onPause;

      /**
       *  Manually seek to a given time of the scene
       *  @function seekToTime.
       *  @param {Number} time - the time to seek
       *  @memberof tscrl.MediaPlaybackDecorator
       */
      element.seekToTime = function (time) {
         element.currentTime = time;
      };

      element.addEventListener = _eventDispatcher.on;
      element.removeEventListener = _eventDispatcher.off;
   };

   return {
      /**
       *  Will decorate an element with the media element api to simulate time playback.
       *  @function decorate
       *  @memberof tscrl.MediaPlaybackDecorator
       *  @param {Element} element - Html element to decorate.
       *  @param {tscml.Scene} scene - The corresponding scene for the element being decorated.
       *  @static
       *  @return new MediaPlaybackDecorator instance
       */
      decorate: function (element, scene) {
         return new MediaPlaybackDecorator(element, scene);
      }
   };
});

var owenge = function() {
	var symbol = {
		mul: '*',
		div: '/',
		add: '+',
		sub: '-',
		grpbeg: '(',
		grpend: ')'
	};

	var ex = {
		divZero: 'divZero',
		isNan: 'isNan',
		invalidArgument: 'invalidArgument'
	};

	var operator = [symbol.mul, symbol.div, symbol.add, symbol.sub];
	var group = [symbol.grpbeg, symbol.grpend];

	// Just another way I want to make a namespace. I
	// don't want to have another js file that has to
	// be referenced just to make this parser works!
	var ns = {
		equation: {
			parse: function(s) {}
		}
	};

	// Function for parsing the string-based equation.
	//
	// Returns: Object with properties - "answer" and "error"
	ns.equation.parse = function(s) {
		// Function for splitting operators and numbers
		// into valid elements.
		//
		// Returns: Array of numbers and operators
		var split = function(s) {
			var ar = [];
			var len = s.length;
			var i = 0;
			var start = 0;

			for (i = 0; i < len; i++) {
				// Get the current character of the formula.
				var ch = s.charAt(i);

				// Get the left character of the current character.
				var left = i === 0 ? '' : s.charAt(i - 1);

				// Ignore if it is not an operator so letters
				// and numbers will be skipped.
				if (!Array.contains(operator, ch)) {
					continue;
				}

				// Evaluate if the operator is actually a "sign".
				// This is for negative numbers where the left
				// character is usually a math operator.
				if (Array.contains(operator, ch) && Array.contains(operator, left)) {
					continue;
				}

				// Parse the number starting from the index of the
				// previous operator upto the current one.
				Array.add(ar, s.substr(start, i - start));

				// Add the operator to the array.
				Array.add(ar, ch);

				// Track the index of the current operator. This
				// will be used for the next numeric parsing.
				start = i + 1;
			}

			// If the array has no elements it only means
			// that the formula doesn't have any operator(s)
			// so we have to assume that the value is a
			// number.
			if (ar.length === 0) {
				return s;
			}

			// The right most number of the formula will NOT be
			// included when parsing so we have to add it to the
			// array based on the last index of the last operator.
			if (start > 0) {
				Array.add(ar, s.substr(start));
			}

			// Return the parsed array values.
			return mdas(ar);
		};

		// Function for eliminating equation groups.
		//
		// Returns: Number as the answer of the equation
		var recurse = function(s) {
			var len = s.length;
			var i = 0;
			var start = 0;
			var prevGrp;
			var parsed = '';

			for (i = 0; i < len; i++) {
				var ch = s.charAt(i);

				// Update the starting index with the latest value.
				if (ch === symbol.grpbeg) {
					start = i + 1;
				}

				// Update the new parsed formula
				parsed += ch;

				// Ignore other characters that is not a group symbol.
				if (!Array.contains(group, ch)) {
					continue;
				}

				if (prevGrp === symbol.grpbeg && ch === symbol.grpend) {
					// Get the inner formula with the parenthesis
					var formula = s.substr(start, i - start);

					// Compute the inner formula using MDAS
					var ans = split(formula);

					// Compute the length of the new formula
					var clen = parsed.length - (formula.length + 2);
					parsed = parsed.substr(0, clen);

					// Add the answer of the parsed inner formula.
					parsed += ans;
				}

				// Track the group symbols
				prevGrp =  ch;
			}

			// If the newly concatenated formula still has
			// groupings then we recurse until all groups
			// are eliminated.
			if ((parsed.indexOf(symbol.grpbeg) != -1) || (parsed.indexOf(symbol.grpend) != -1)) {
				return recurse(parsed);
			}

			// If you reach this part it only means that
			// all groups were eliminated and the final
			// result is ready for the last computation.
			return split(parsed);
		};

		var error = '';
		var ans;

		try {
			ans = recurse(s);

			if (isNaN(ans)) {
				throw ex.isNan;
			}
		}
		catch (e) {
			ans = 'n/a';

			if (e == ex.divZero) {
				error = 'Cannot perform division by zero';
			}
			else if (e == ex.isNan) {
				error = 'Invalid formula';
			}
			else if (e == ex.invalidArgument) {
				error = 'Invalid argument';
			}
		}

		return {
			error: error,
			answer: ans
		};
	};

	// Function for computing equation based on MDAS.
	//
	// Returns: Numeric value as result of computation
	var mdas = function(ar) {
		// Function for computing basic math operation.
		//
		// Returns: Numeric value as result computation
		var compute = function(n1, n2, op) {
			switch (op) {
				case symbol.add:
					return Number(n1) + Number(n2);
				case symbol.sub:
					return Number(n1) - Number(n2);
				case symbol.mul:
					return Number(n1) * Number(n2);
				case symbol.div:
					if (Number(n2) === 0) {
						throw ex.divZero;
					}

					return Number(n1) / Number(n2);
			}

			// You're not suppose to reach this point. If you
			// do then you are passing the wrong values!
			throw ex.invalidArgument;
		};

		// Function for computing equation applying
		// MDAS rule. Operators that are passed in
		// the parameter will be basis of computation.
		// Operators not passed will be ignored.
		//
		// Returns: Array of COMPUTED numbers and operators
		var applyRule = function(ar, ops) {
			var len = ar.length;
			var i = 0;
			var prevOp;
			var parsed = [];

			for (i = 0; i < len; i++) {
				var mod = i % 2;

				// Skip if it is not an operator.
				if (mod === 0) {
					continue;
				}

				// If the equation is 2+3 then
				// num1 is 2
				// num2 is 3
				// op is +
				var num1 = ar[i - 1];
				var num2 = ar[i + 1];
				var op = ar[i];

				// If the current operator is the one
				// that will be used for computation then
				// we ignore it.
				if (!Array.contains(ops, op)) {
					// Check if the previous operator is used
					// for the calculation. If not then we
					// add the current number to the parsed array.
					if (!Array.contains(ops, prevOp)) {
						Array.add(parsed, num1);
					}

					// Add ignored operator to the parsed array.
					Array.add(parsed, op);
				}
				else {
					// If the previous operator is found in
					// the list of operators to be used for
					// computation, then we get the previous
					// oomputed value in the array.
					if (Array.contains(ops, prevOp)) {
						num1 = parsed[parsed.length - 1];
					}

					// Compute the equation.
					var ans = compute(num1, num2, op);

					// Replace the last value in the array
					// with the new parsed value.
					if (Array.contains(ops, prevOp)) {
						parsed[parsed.length - 1] = ans;
					}
					else {
						Array.add(parsed, ans);
					}
				}
				// Track the previous operator.
				prevOp = op;
			}

			// We have to add the last value of the formula if the
			// last operator it used for computation.
			if (!Array.contains(ops, prevOp)) {
				// Get the last operator in the array.
				Array.add(parsed, ar[len - 1]);
			}

			return parsed;
		};

		// Apply MDAS rules to the equation
		ar = applyRule(ar, ['*', '/']);
		ar = applyRule(ar, ['+', '-']);

		// Return the final answer of the computation
		return ar.length === 0 ? 0 : ar[0];
	};

	// Array extensions
	if (!Array.contains) {
		Array.contains = function(array, o) {
			var len = array.length;
			var i = 0;

			for (i = 0; i < len; i++) {
				if (array[i] === o) {
					return true;
				}
			}

			return false;
		};
	}

	if (!Array.add) {
		Array.add = function(array, o) {
			array[array.length] = o;
		};
	}

	return ns;
}();

(function (window, audioNarrationViewFactory) {
   "use strict";

   var namespace = (typeof exports !== 'undefined') ? module.exports : (window.tscrl = window.tscrl || {});
   namespace.AudioNarrationView = audioNarrationViewFactory(window, window.Q, namespace.EventDispatcher, namespace.constants);

})(this, function (window, Q, EventDispatcher, constants) {

   "use strict";

   var noOpAudioNarrationFactory = function() {
      var noop = function() {};
      return {
         currentTime: 0,
         duration: 0,
         element: null,
         play: noop,
         pause: noop,
         volume: constants.DEFAULT_VOLUME,
         seekToTime: noop,
         on: noop,
         off: noop,
         ready: Q(),
         metadataReady: Q(),
         loopOnPlay: false
      };
   };

   /**
    * @memberof tscrl
    * @class AudioNarrationView
    * @classdesc This is a factory for audio narrations
    * @param {Object} audioNarration - The audioNarration object from a scene
    * @param {String} audioNarration.id - id of audio narration
    * @param {String} audioNarration.uri - Uri for audio narration media
    * @param {String} audioNarration.mimeType - Mimetype for media
    * @param {tscrl.UriBuilder} uriBuilder - UriBuilder used to resolve file path
    */
   var AudioNarrationView = function(audioNarration, uriBuilder) {
      var _audioElement,
         _ready,
         _metadataReadyDeferred,
         _eventDispatcher,
         _canPlay,
         _volume,
         _loopOnPlay,
         _public;

      _eventDispatcher = EventDispatcher.create();
      _metadataReadyDeferred = Q.defer();
      _volume = constants.DEFAULT_VOLUME;

      var onCanPlay = function() {
         _canPlay = true;
         _audioElement.removeEventListener("canplay", onCanPlay);
      };

      _audioElement = window.document.createElement("audio");
      _audioElement.preload = "auto";
      _audioElement.addEventListener("canplay", onCanPlay);
      _canPlay = false;
      _loopOnPlay = false;

      _ready = uriBuilder.getUri(audioNarration).then(function(uri){
         _audioElement.addEventListener('loadedmetadata', function loaded() {
            _audioElement.removeEventListener('loadedmetadata', loaded);
            _metadataReadyDeferred.resolve();
         });
         _audioElement.addEventListener('error', function audioError(error) {
            _audioElement.removeEventListener('error', audioError);
            _metadataReadyDeferred.reject(error);
         });
         _audioElement.src = uri;
      });

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Element} element - Audio dom element.
          */
         element: {
            get: function() {
               return _audioElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {String} type - type of source media for a scene.
          */
         type: {
           value: constants.SOURCE_VIEW_TYPE.AUDIO
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Number} currentTime - Current time of the audio element.
          */
         currentTime: {
            get: function() {
               return _audioElement.currentTime;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.AudioNarrationView
          *  @property {Number} playbackRate - Playback rate for audio narration.
          */
         playbackRate: {
            get: function() {
               return _audioElement.playbackRate;
            },
            set: function(value) {
               _audioElement.playbackRate = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Number} duration - Duration of audio view.
          */
         duration: {
            get: function () {
               return isNaN(_audioElement.duration) ? 0 : _audioElement.duration;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.VideoView
          *  @property {Number} volume - Volume for video view
          */
         volume: {
            get: function () {
               return _volume;
            },
            set: function(value) {
               _volume = value;
               _metadataReadyDeferred.promise.then(function() {
                  _audioElement.volume = _volume;
               });
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function() {
               return _ready;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Object} metadataReady - Q Promise that resolves when metadata is available.
          */
         metadataReady: {
            get: function () {
               return _metadataReadyDeferred.promise;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.AudioNarrationView
          *  @property {Boolean} loopOnPlay - Video will loopOnPlay when play is called and it is at the end of the video.
          */
         loopOnPlay: {
            get: function () {
               return _loopOnPlay;
            },
            set: function (value) {
               _loopOnPlay = value;
            }
         }
      });

      /**
       *  Play audio element.
       *  @function play.
       *  @memberof tscrl.AudioNarrationView
       */
      _public.play = function() {
         var notifyOnRestart = false;
         if(_audioElement.ended && !_loopOnPlay) {
            return;
         }

         if(_audioElement.ended && _loopOnPlay) {
            notifyOnRestart = true;
         }

         _audioElement.play();

         if(notifyOnRestart) {
            _eventDispatcher.trigger("mediaRestarted", {currentTarget: _public});
         }
      };

      /**
       *  Pause audio element.
       *  @function play.
       *  @memberof tscrl.AudioNarrationView
       */
      _public.pause = function() {
         _audioElement.pause();
      };

      /**
       *  Seek to time in audio element.
       *  @function seekToTime
       *  @memberof tscrl.AudioNarrationView
       *  @param {Number} time - Time in seconds to seek to.
       */
      _public.seekToTime = function(time) {
         if (!_canPlay) {
            return;
         }

         if (time > _audioElement.duration) {
            time = _audioElement.duration;
         }
         _audioElement.currentTime = time;
      };

      /**
       *  Add event listener to audio narration view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.AudioNarrationView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to audio narration view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.AudioNarrationView
       */
      _public.off = _eventDispatcher.off;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new audio narration.
       *  @function create
       *  @memberof tscrl.AudioNarrationView
       *  @static
       *  @param {Object} audioNarration - The audioNarration object from a scene
       *  @param {String} audioNarration.id - id of audio narration
       *  @param {String} audioNarration.uri - Uri for audio narration media
       *  @param {String} audioNarration.mimeType - Mimetype for media
       *  @param {tscrl.UriBuilder} uriBuilder - UriBuilder used to resolve file paths
       *  @return Audio element view
       */
      create: function (audioNarration, uriBuilder) {
         if (audioNarration) {
            return new AudioNarrationView(audioNarration, uriBuilder);
         }
         return noOpAudioNarrationFactory();
      }
   };
});

(function (window, emptySourceViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.EmptySourceView = emptySourceViewFactory(window, window.Q, window.tscml.sceneType, namespace.MediaPlaybackDecorator, namespace.EventDispatcher, namespace.constants);

})(this, function (window, Q, sceneType, MediaPlaybackDecorator, EventDispatcher, constants) {

   "use strict";

   var _customSceneElementBySceneType = {};

   /**
    * @memberof tscrl
    * @class EmptySourceView
    * @param {Object} params - Params for the view.
    * @param {tscml.Scene} [params.scene] - TSC Media Lib Scene Instance.
    * @param {String} [params.viewClassName] - Class to apply to the view element.
    * @classdesc View for Scenes with no source provided.
    */
   var EmptySourceView = function (params) {
      var _element,
         _eventDispatcher,
         _customElement,
         _loopOnPlay,
         _public;

      _element = window.document.createElement("div");
      _element.className = params.viewClassName;

      if(params.scene && _customSceneElementBySceneType[params.scene.type] !== undefined) {
         var customElementConstructor = _customSceneElementBySceneType[params.scene.type];
         _customElement = customElementConstructor();
         _element.appendChild(_customElement);
      }

      _loopOnPlay = false;
      _eventDispatcher = EventDispatcher.create();

      var noop = function() {return true;};

      MediaPlaybackDecorator.decorate(_element, params.scene);

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {Element} element - Empty Element in view.
          */
         element: {
            get: function () {
               return _element;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {String} type - Type of source view
          */
         type: {
            value: constants.SOURCE_VIEW_TYPE.EMPTY
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {Number} duration - Duration of Empty view.
          */
         duration: {
            get: function () {
               return _element.duration;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.EmptySourceView
          *  @property {Number} volume - Volume for empty view
          */
         volume: {
            get: function () {
               return constants.DEFAULT_VOLUME;
            },
            set: noop
         },
         /**
          *  @public
          *  @memberof tscrl.EmptySourceView
          *  @property {Number} playbackRate - Playback rate for audio narration.
          */
         playbackRate: {
            get: function() {
               return _element.playbackRate;
            },
            set: function(value) {
               _element.playbackRate = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function () {
               return Q();
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {Object} metadataReady - Q Promise that resolves when view is ready.
          */
         metadataReady: {
            get: function() {
               return Q();
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceView
          *  @property {Boolean} canPlay - View can be played, empty source will always be true.
          */
         canPlay: {
            get: function () {
               return true;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.EmptySourceView
          *  @property {Boolean} loopOnPlay - View will loop scene time playback when play is called and at the end of the view duration.
          */
         loopOnPlay: {
            get: function () {
               return _loopOnPlay;
            },
            set: function (value) {
               _loopOnPlay = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.EmptySourceVieww
          *  @property {Boolean} isScalable - Whether or not this view should be scaled
          */
         isScalable: {
            value: false
         }
      });

      /**
       *  Manually seek to a given time of the scene
       *  @function seekToTime.
       *  @param {Number} time - the time to seek
       *  @memberof tscrl.EmptySourceView
       */
      _public.seekToTime = function (time) {
         _element.currentTime = time;
      };

      /**
       *  Manually seek to a given time of the scene
       *  @function canSeekToTime.
       *  @memberof tscrl.EmptySourceView
       *  @return {Boolean} always returns true.
       */
      _public.canSeekToTime = function() {
         return true;
      };

      /**
       *  Play the decorated element of this view
       *  @function play
       *  @memberof tscrl.EmptySourceView
       */
      _public.play = function() {
         if(_element.ended && !_loopOnPlay) {
            return;
         }
         var notifyOnRestart = false;
         if(_element.ended && _loopOnPlay) {
            notifyOnRestart = true;
         }

         _element.play();

         if(notifyOnRestart) {
            _eventDispatcher.trigger("mediaRestarted", {currentTarget: _public});
         }
      };

      /**
       *  Play the decorated element of this view
       *  @function pause
       *  @memberof tscrl.EmptySourceView
       */
      _public.pause = function() {
         _element.pause();
      };

      /**
       *  Add event listener to empty source view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.EmptySourceView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Add event listener to empty source view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.EmptySourceView
       */
      _public.off = _eventDispatcher.off;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new EmptySourceView object.
       *  @function create
       *  @param {Object} params - Params for the view.
       *  @param {tscml.Scene} [params.scene] - TSC Media Lib Scene Instance.
       *  @param {String} [params.viewClassName] - Class to apply to the view element.
       *  @memberof tscrl.EmptySourceView
       *  @static
       *  @return new EmptySourceView instance
       */
      create: function (params) {
         return new EmptySourceView(params);
      },
      /**
       *  Register custom element to be displayed within the empty source element.
       *  @function registerCustomElementForSceneType
       *  @param {Function} ElementConstructor - Custom Element constructor.
       *  @param {String} sceneType - Scene type
       *  @memberof tscrl.EmptySourceView
       *  @static
       */
      registerCustomElementForSceneType: function(ElementConstructor, sceneType) {
         if (typeof ElementConstructor !== "function") {
            throw new Error("Empty Source View.registerCustomElement: ElementConstructor must be a function.");
         }
         _customSceneElementBySceneType[sceneType] = ElementConstructor;
      }
   };
});

(function (window, errorViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.ErrorView = errorViewFactory(window, window.Q, namespace.MediaPlaybackDecorator, namespace.constants);

})(this, function (window, Q, MediaPlaybackDecorator, constants) {

   "use strict";

   /**
    * @memberof tscrl
    * @class ErrorView
    * @param {Object} params - Params for the view.
    * @param {String} [params.viewClassName] - Class to apply to the view element.
    * @param {String} [params.primaryErrorMessage] - The primary error message text.
    * @param {String} [params.secondaryErrorMessage] - The secondary error message text.
    * @classdesc View for displaying error messages.
    */
   var ErrorView = function (params) {
      var _rootElement,
         _primaryErrorMessageElement,
         _secondaryErrorMessageElement,
         _public;

      _rootElement = window.document.createElement("div");
      _rootElement.className = params.viewClassName;

      _primaryErrorMessageElement = window.document.createElement("div");
      _primaryErrorMessageElement.textContent = params.primaryErrorMessage;
      _primaryErrorMessageElement.classList.add("primary-error-message");
      _secondaryErrorMessageElement = window.document.createElement("div");
      _secondaryErrorMessageElement.textContent = params.secondaryErrorMessage;
      _secondaryErrorMessageElement.classList.add("secondary-error-message");

      _rootElement.appendChild(_primaryErrorMessageElement);
      _rootElement.appendChild(_secondaryErrorMessageElement);

      var noop = function() {return true;};

      MediaPlaybackDecorator.decorate(_rootElement, undefined);

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Element} element - root Element in view.
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {String} type - Type of source view
          */
         type: {
            value: constants.SOURCE_VIEW_TYPE.ERROR
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Number} duration - Duration of error view (always zero).
          */
         duration: {
            get: function () {
               return 0;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ErrorView
          *  @property {Number} volume - Volume for error view
          */
         volume: {
            get: function () {
               return constants.DEFAULT_VOLUME;
            },
            set: noop
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function () {
               return Q();
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Object} metadataReady - Q Promise that resolves when metadata is available.
          */
         metadataReady: {
            get: function () {
               return Q();
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Boolean} canPlay - This view cannot be played, will always be false.
          */
         canPlay: {
            get: function () {
               return false;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ErrorView
          *  @property {Boolean} isScalable - Whether or not this view should be scaled
          */
         isScalable: {
            value: false
         }
      });


      _public.seekToTime = noop;
      _public.canSeekToTime = noop;
      _public.play = noop;
      _public.pause = noop;
      _public.on = noop;
      _public.off = noop;

      return _public;
   };

   return {
      /**
       * Factory method that returns a new ErrorView object.
       * @function create
       * @param {Object} params - Params for the view.
       * @param {String} [params.viewClassName] - Class to apply to the view element.
       * @param {String} [params.primaryErrorMessage] - The primary error message text.
       * @param {String} [params.secondaryErrorMessage] - The secondary error message text.
       * @memberof tscrl.ErrorView
       * @static
       * @return new ErrorView instance
       */
      create: function (params) {
         return new ErrorView(params);
      }
   };
});

(function (window, imageViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.ImageView = imageViewFactory(window, window.Q, namespace.MediaPlaybackDecorator, namespace.EventDispatcher, namespace.constants);

})(this, function (window, Q, MediaPlaybackDecorator, EventDispatcher, constants) {

   "use strict";

   /**
    * @memberof tscrl
    * @class ImageView
    * @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
    * @param {Object} params - Params for the view.
    * @param {tscml.Scene} [params.scene] - TSC Media Lib Scene Instance.
    * @param {tscml.Source} [params.source] - TSC Media Lib Source Instance.
    * @param {String} [params.viewClassName] - Class to apply to the view element.
    * @classdesc View for Image content
    */
   var ImageView = function (uriBuilder, params) {
      var _imageElement,
         _metadata,
         _metadataReadyDeferred,
         _eventDispatcher,
         _loopOnPlay,
         _public,
         _ready;

      _imageElement = window.document.createElement("img");
      _imageElement.className = params.viewClassName;
      if (params.rotate) {
         var rotateClass = constants.SOURCE_VIEW_ROTATE[params.rotate];
         if (rotateClass) {
            _imageElement.classList.add(rotateClass);
         }
      }

      _eventDispatcher = EventDispatcher.create();
      _metadataReadyDeferred = Q.defer();
      _metadata = {};

      _loopOnPlay = false;

      _ready = uriBuilder.getUri(params.source).then(function (mediaUri) {
         var image = _imageElement,
            metadata = _metadata,
            metadataReady = _metadataReadyDeferred;
         image.onload = function imageLoaded() {
            image.onload = null;
            metadata.width = image.naturalWidth;
            metadata.height = image.naturalHeight;
            metadataReady.resolve(metadata);
         };
         image.onerror = function imageError(error) {
            image.onerror = null;
            metadataReady.reject(error);
         };
         image.src = mediaUri;
      });

      var noop = function() {};

      MediaPlaybackDecorator.decorate(_imageElement, params.scene);

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Element} element - Image Element in view.
          */
         element: {
            get: function () {
               return _imageElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {String} type - Type of source view
          */
         type: {
            value: constants.SOURCE_VIEW_TYPE.IMAGE
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Number} duration - Duration of image view.
          */
         duration: {
            get: function () {
               return _imageElement.duration;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ImageView
          *  @property {Number} volume - Volume property for image view.
          */
         volume: {
            get: function () {
               return constants.DEFAULT_VOLUME;
            },
            set: noop
         },
         /**
          *  @public
          *  @memberof tscrl.ImageView
          *  @property {Number} playbackRate - Playback rate for image view.
          */
         playbackRate: {
            get: function() {
               return _imageElement.playbackRate;
            },
            set: function(value) {
               _imageElement.playbackRate = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Object} metadataReady - Q Promise that resolves when metadata is available.
          */
         metadataReady: {
            get: function () {
               return _metadataReadyDeferred.promise;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function () {
               return _ready;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Boolean} canPlay - View can be played, for images this will aways be true.
          */
         canPlay: {
            get: function () {
               return true;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ImageView
          *  @property {Boolean} loopOnPlay - View will loop image time playback when play is called and at the end of the view duration.
          */
         loopOnPlay: {
            get: function () {
               return _loopOnPlay;
            },
            set: function (value) {
               _loopOnPlay = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ImageView
          *  @property {Boolean} isScalable - Whether or not this view should be scaled
          */
         isScalable: {
            value: true
         }
      });

      /**
       *  Manually seek to a given time of the scene
       *  @function seekToTime.
       *  @param {Number} time - the time to seek
       *  @memberof tscrl.ImageView
       */
      _public.seekToTime = function (time) {
         _public.element.currentTime = time;
      };

      /**
       *  Manually seek to a given time of the scene
       *  @function canSeekToTime.
       *  @memberof tscrl.ImageView
       *  @return {Boolean} always returns true.
       */
      _public.canSeekToTime = function() {
         return true;
      };

      /**
       *  Play the media content of this view
       *  @function play
       *  @memberof tscrl.ImageView
       */
      _public.play = function () {
         if(_imageElement.ended && !_loopOnPlay) {
            return;
         }
         var notifyOnRestart = false;
         if(_imageElement.ended && _loopOnPlay) {
            notifyOnRestart = true;
         }

         _imageElement.play();

         if(notifyOnRestart) {
            _eventDispatcher.trigger("mediaRestarted", {currentTarget: _public});
         }
      };

      /**
       *  Play the media content of this view
       *  @function pause
       *  @memberof tscrl.ImageView
       */
      _public.pause = function () {
         _imageElement.pause();
      };

      /**
       *  Add event listener to image view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ImageView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to image view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ImageView
       */
      _public.off = _eventDispatcher.off;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new ImageView object.
       *  @function create
       *  @memberof tscrl.ImageView
       *  @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
       *  @param {Object} params - Params for the view.
       *  @param {tscml.Scene} [params.scene] - TSC Media Lib Scene Instance.
       *  @param {tscml.Source} [params.source] - TSC Media Lib Source Instance.
       *  @param {String} [params.viewClassName] - Class to apply to the view element.
       *  @static
       *  @return new ImageView instance
       */
      create: function (uriBuilder, params) {
         return new ImageView(uriBuilder, params);
      }
   };
});

(function (window, videoViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.VideoView = videoViewFactory(window, window.Q, namespace.EventDispatcher, namespace.constants);

})(this, function (window, Q, EventDispatcher, constants) {

   "use strict";

   /**
    * @memberof tscrl
    * @class VideoView
    * @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
    * @param {Object} params - Params for the view.
    * @param {Object} [params.source] - TSC Media Lib Source Instance.
    * @param {String} [params.viewClassName] - Class to apply to the view element.
    * @classdesc View for Video content
    */
   var VideoView = function (uriBuilder, params) {
      var _videoElement,
         _ready,
         _metadata,
         _metadataReadyDeferred,
         _eventDispatcher,
         _canPlay,
         _loopOnPlay,
         _volume,
         _public;

      _eventDispatcher = EventDispatcher.create();
      _metadataReadyDeferred = Q.defer();
      _metadata = {};
      _volume = constants.DEFAULT_VOLUME;
      _loopOnPlay = false;

      var onCanPlay = function () {
         _canPlay = true;
         _videoElement.removeEventListener("canplay", onCanPlay);
      };

      _videoElement = window.document.createElement("video");
      _videoElement.addEventListener("canplay", onCanPlay);
      _canPlay = false;

      _ready = uriBuilder.getUri(params.source).then(function (mediaUri) {
         var video = _videoElement,
            metadata = _metadata,
            metadataReady = _metadataReadyDeferred;
         video.addEventListener('loadedmetadata', function loaded() {
            video.removeEventListener('loadedmetadata', loaded);
            metadata.width = video.videoWidth;
            metadata.height = video.videoHeight;
            metadataReady.resolve(metadata);
         });
         video.addEventListener('error', function videoError(error) {
            video.removeEventListener('error', videoError);
            _metadataReadyDeferred.reject(error);
         });
         video.src = mediaUri;
      });

      _videoElement.preload = "auto";
      _videoElement.className = params.viewClassName;

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Element} element - Video Element in view.
          */
         element: {
            get: function () {
               return _videoElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {String} type - Type of source view
          */
         type: {
            value: constants.SOURCE_VIEW_TYPE.VIDEO
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Number} duration - Duration of video view.
          */
         duration: {
            get: function () {
               return isNaN(_videoElement.duration) ? 0 : _videoElement.duration;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.VideoView
          *  @property {Number} volume - Volume for video view
          */
         volume: {
            get: function () {
               return _volume;
            },
            set: function(value) {
               _volume = value;
               _metadataReadyDeferred.promise.then(function() {
                  _videoElement.volume = _volume;
               });
            }
         },
         /**
          *  @public
          *  @memberof tscrl.VideoView
          *  @property {Number} playbackRate - Playback rate for video view.
          */
         playbackRate: {
            get: function() {
               return _videoElement.playbackRate;
            },
            set: function(value) {
               _videoElement.playbackRate = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function () {
               return _ready;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Object} metadataReady - Q Promise that resolves when metadata is available.
          */
         metadataReady: {
            get: function () {
               return _metadataReadyDeferred.promise;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Boolean} canPlay - View can be played.
          */
         canPlay: {
            get: function () {
               return _canPlay;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Boolean} loopOnPlay - Video will loopOnPlay when play is called and it is at the end of the video.
          */
         loopOnPlay: {
            get: function () {
               return _loopOnPlay;
            },
            set: function (value) {
               _loopOnPlay = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Boolean} ended - Is view at the end.
          */
         ended: {
            get: function () {
               return _videoElement.ended;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {Boolean} isScalable - Whether or not this view should be scaled
          */
         isScalable: {
            value: true
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.VideoView
          *  @property {String} src - video source uri
          */
         src: {
            get: function () {
               return _videoElement.src;
            },
            set: function (value) {
               _videoElement.src = value;
            }
         }
      });

      /**
       *  Manually seek to a given time of the scene
       *  @function seekToTime.
       *  @param {Number} time - the time to seek
       *  @memberof tscrl.VideoView
       */
      _public.seekToTime = function (time) {
         if (!_canPlay) {
            return;
         }

         if(time <= _videoElement.duration) {
            _videoElement.currentTime = time;
         } else if (_loopOnPlay) {
            _videoElement.currentTime = (time % _videoElement.duration);
         } else {
            _videoElement.currentTime = _videoElement.duration;
         }
      };

      /**
       *  Play the media content of this view
       *  @function play
       *  @memberof tscrl.VideoView
       */
      _public.play = function () {
         if(!_canPlay || (_videoElement.ended && !_loopOnPlay)) {
            return;
         }
         var notifyOnRestart = false;
         if(_videoElement.ended && _loopOnPlay) {
            notifyOnRestart = true;
         }

         _videoElement.play();

         if(notifyOnRestart) {
            _eventDispatcher.trigger("mediaRestarted", {currentTarget: _public});
         }
      };

      /**
       *  Pause the media content of this view
       *  @function pause
       *  @memberof tscrl.VideoView
       */
      _public.pause = function () {
         _videoElement.pause();
      };

      /**
       *  Add event listener to video view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.VideoView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to video view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.VideoView
       */
      _public.off = _eventDispatcher.off;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new VideoView object.
       *  @function create
       *  @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
       *  @param {Object} params - Params for the view.
       *  @param {Object} [params.source] - TSC Media Lib Source Instance.
       *  @param {String} [params.viewClassName] - Class to apply to the view element.
       *  @memberof tscrl.VideoView
       *  @static
       *  @return new VideoView instance
       */
      create: function (uriBuilder, params) {
         return new VideoView(uriBuilder, params);
      }
   };
});

(function (window, textCalloutSceneViewObjectFactory) {
   "use strict";
   var namespace = window.tscrl = window.tscrl || {};
   namespace.TextCalloutSceneViewObject = textCalloutSceneViewObjectFactory(window, window._, window.owenge, namespace.EventDispatcher, namespace.ThemeWrapper, namespace.transformProvider, namespace.constants);
})(this, function (window, _, owenge, EventDispatcher, ThemeWrapper, transformProvider, constants) {

   "use strict";

   /**
    * Theme tag model change event .
    * @event tscrl.TextCalloutSceneViewObject#themeTagModelChange
    * @type {object}
    * @property {Object} eventData - Data info passed with event.
    * @property {String} eventData.type - Event name
    * @property {String} eventData.themeTag - Theme tag changed
    * @property {String} eventData.defProperty - Def property changed
    * @property {String} eventData.value - Changed value for the def property.
    */

   /**
    *  @memberof tscrl
    *  @class TextCalloutSceneViewObject
    *  @param {tscrl.SceneView} sceneViewParent - SceneView parent for this SceneViewObject
    *  @param {Object} themeableItem - tscml.Scene.themeables array item this object will render
    *  @fires tscrl.TextCalloutSceneViewObject#themeTagModelChange
    */
   var TextCalloutSceneViewObject = function (sceneViewParent, themeableItem) {
      var _public,
         _rootElement,
         _viewElement,
         _editableElement,
         _eventDispatcher,
         _titleText,
         _editMode,
         _sceneViewParent,
         _themeWrapper,
         _themeTag,
         _isEditing,
         _transform;

      _isEditing = false;
      _editMode = false;
      _eventDispatcher = EventDispatcher.create();
      _sceneViewParent = sceneViewParent;
      _themeWrapper = _sceneViewParent.sceneTrackView.projectView.themeWrapper;
      _themeTag = themeableItem.themeTag;
      _transform = {
         position: {
            x: 0,
            y: 0,
            z: 0
         }
      };

      _rootElement = window.document.createElement("div");
      _viewElement = window.document.createElement("div");
      _viewElement.classList.add("text-callout-view");
      _editableElement = window.document.createElement("input");
      _editableElement.type = "text";
      _editableElement.maxLength = constants.TEXT_INPUT_MAX_LENGTH;
      _editableElement.placeholder = constants.TITLE_TITLE_PLACEHOLDER_TEXT;
      _editableElement.classList.add("text-callout-editable");
      _editableElement.style.backgroundColor = "transparent";

      _rootElement.appendChild(_viewElement);
      _rootElement.appendChild(_editableElement);

      var onInputBlur = function () {
         if (_editableElement.value !== _titleText) {
            _public.title = _editableElement.value;
            _eventDispatcher.trigger("themeTagModelChange", {
               themeTag: themeableItem.themeTag,
               defProperty: "text",
               value: _titleText
            });
         }
         _public.isEditing = false;
      };

      var onUpdateTheme = function (eventData) {
         var themeTagObj = _themeWrapper.getThemeForTag(_themeTag);
         if (themeTagObj) {
            applyTheme(themeTagObj);
         }
      };

      var onEnableEditing = function () {
         _public.isEditing = true;
      };

      var bindEvents = function () {
         _viewElement.addEventListener("click", onEnableEditing);
         _editableElement.addEventListener("blur", onInputBlur);
         _themeWrapper.on(ThemeWrapper.events.THEME_UPDATED, onUpdateTheme);
      };

      var unbindEvents = function () {
         _viewElement.removeEventListener("click", onEnableEditing);
         _editableElement.removeEventListener("blur", onInputBlur);
         _themeWrapper.off(ThemeWrapper.events.THEME_UPDATED, onUpdateTheme);
      };

      var onEditableChange = function () {
         if (_editMode) {
            _viewElement.style.display = "none";
            _editableElement.style.display = "block";
            _editableElement.focus();
         } else {
            _viewElement.style.display = "block";
            _editableElement.style.display = "none";
         }
      };

      var horizAlign2textAlign = function (def) {
         return def["horizontal-alignment"] || "center";
      };

      var fontWeightString2Value = function (fontDef) {
         var fontWeightString = fontDef.weight || constants.DEFAULT_THEME_TEXT_FONT_WEIGHT;
         fontWeightString = fontWeightString.toLowerCase();
         switch (fontWeightString) {
            case "thin":
               return 100;
            case "extra light":
               return 200;
            case "light":
               return 300;
            case "normal":
               return 400;
            case "medium":
               return 500;
            case "semi bold":
               return 600;
            case "bold":
               return 700;
            case "extra bold":
               return 800;
            case "black":
               return 900;
            default:
               return 400;
         }
      };

      var float2intColor = function (num) {
         return Math.round(num * 255);
      };

      var def2RgbColor = function (fontDef) {
         var r = float2intColor(fontDef["color-red"] || constants.DEFAULT_THEME_TEXT_FONT_COLOR_COMPONENT);
         var g = float2intColor(fontDef["color-green"] || constants.DEFAULT_THEME_TEXT_FONT_COLOR_COMPONENT);
         var b = float2intColor(fontDef["color-blue"] || constants.DEFAULT_THEME_TEXT_FONT_COLOR_COMPONENT);

         return "rgb(" + r + "," + g + "," + b + ")";
      };

      var def2FontSize = function (fontDef, textBoxSize, scaleFactor) {
         return calculateEquationAsFloat(fontDef.size || constants.DEFAULT_THEME_TEXT_FONT_SIZE, true, textBoxSize, scaleFactor) + "px";
      };

      var def2FontName = function (fontDef) {
         return fontDef.name || constants.DEFAULT_THEME_TEXT_FONT_NAME;
      };

      var calculateEquationAsFloat = function (equation, handleWidthAndHeight, textBoxSize, scaleFactor) {
         var cleanEqn = equation || "0";
         cleanEqn = "" + cleanEqn;
         if (handleWidthAndHeight) {
            cleanEqn = cleanEqn.replace(/width/g, "" + textBoxSize.width);
            cleanEqn = cleanEqn.replace(/height/g, "" + textBoxSize.height);
         }
         cleanEqn = cleanEqn.replace(/scale/g, "" + scaleFactor);
         return owenge.equation.parse(cleanEqn).answer;
      };

      var parameters2Translation = function (textBoxSize, themeTagParameters) {
         var scaleFactor = 1.0;

         var xVal = calculateEquationAsFloat(themeTagParameters.translation0, true, textBoxSize, scaleFactor);
         var yVal = calculateEquationAsFloat(themeTagParameters.translation1, true, textBoxSize, scaleFactor);
         var zVal = calculateEquationAsFloat(themeTagParameters.translation2, true, textBoxSize, scaleFactor);

         return {
            x: xVal || 0,
            // y up is negative in CSS so reverse it.
            y: -(yVal || 0),
            z: zVal || 0
         };
      };

      var fontTrackingString2letterSpacing = function (fontDef) {
         if (fontDef.tracking === undefined) {
            return "normal";
         }
         return fontDef.tracking + "em";
      };

      var applyFontStyleToElement = function (style, fontDef, textBoxSize, scaleFactor) {
         style.color = def2RgbColor(fontDef);
         style.fontSize = def2FontSize(fontDef, textBoxSize, scaleFactor);
         style.fontFamily = def2FontName(fontDef);
         style.fontWeight = fontWeightString2Value(fontDef);
         style.letterSpacing = fontTrackingString2letterSpacing(fontDef);
         style.margin = "0px";
         style.padding = "0px";
         style.border = "0px";
      };

      var def2textBoxSize = function (def, scaleFactor) {
         return {
            width: calculateEquationAsFloat(def.width, false, {width: 0, height: 0}, scaleFactor),
            height: calculateEquationAsFloat(def.height, false, {width: 0, height: 0}, scaleFactor)
         };
      };

      var applyAllCaps = function (element, def) {
         var useAllCaps = def["all-caps"] || false;
         if (useAllCaps) {
            element.style.textTransform = "uppercase";
         }
      };

      var applyVerticalAlignment = function(def, textBoxSize) {
         var vertAlign = def["vertical-alignment"] || constants.DEFAULT_THEME_TEXT_VERT_ALIGN;
         if ( vertAlign === "middle" || vertAlign === "center" ) {
            _viewElement.style.lineHeight = textBoxSize.height + "px";
         } else if ( vertAlign === "top" ) {
            // TODO: Support 'top' vertical alignment.
         } else if (vertAlign === "bottom") {
            // TODO: Support 'bottom' vertical alignment.
         }
      };

      var applyTheme = function (themeTagObj) {
         var def = themeTagObj.def;

         var scaleFactor = 1.0;

         var textBoxSize = def2textBoxSize(def, scaleFactor);
         applyFontStyleToElement(_viewElement.style, def.font, textBoxSize, scaleFactor);
         applyFontStyleToElement(_editableElement.style, def.font, textBoxSize, scaleFactor);

         _viewElement.style.whiteSpace = "nowrap";

         _viewElement.setAttribute("ng-bind","title");

         _rootElement.style.position = "absolute";
         _rootElement.style.width = textBoxSize.width + "px";
         _rootElement.style.height = textBoxSize.height + "px";
         _viewElement.style.textAlign = horizAlign2textAlign(def);
         _editableElement.style.textAlign = horizAlign2textAlign(def);

         _editableElement.style.width = textBoxSize.width + "px";
         _editableElement.style.height = textBoxSize.height + "px";

         applyAllCaps(_viewElement, def);
         applyAllCaps(_editableElement, def);

         applyVerticalAlignment(themeTagObj.def, textBoxSize);

         // Center text in the view as per spec (origin is center of canvas)
         _transform.position = parameters2Translation(textBoxSize, themeTagObj.parameters);
         var fullHeight = transformProvider.canvasRect.height;
         var computedOffsetY = ((fullHeight * 0.5) - (textBoxSize.height * 0.5));
         _rootElement.style.top = computedOffsetY + "px";

         var fullWidth = transformProvider.canvasRect.width;
         var computedOffsetX = ((fullWidth * 0.5) - (textBoxSize.width * 0.5));
         _rootElement.style.left = computedOffsetX + "px";

         // Translate to appropriate location based on theme file
         _rootElement.style.transform = "translate(" + _transform.position.x + "px, " + _transform.position.y + "px)";
         _rootElement.style['-webkit-transform'] = "translate(" + _transform.position.x + "px, " + _transform.position.y + "px)";
      };

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.TextCalloutSceneViewObject
          *  @property {Object} element - Root dom element for this SceneViewObject.
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.TextCalloutSceneViewObject
          *  @property {string} title - Title text for this SceneViewObject
          */
         title: {
            get: function () {
               return _titleText;
            },
            set: function (title) {
               _titleText = title;
               _viewElement.innerHTML = _.escape(title);
               _editableElement.value = title;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.TextCalloutSceneViewObject
          *  @property {Boolean} editMode - Allow the text to be edited
          */
         editMode: {
            get: function () {
               return _editMode;
            },
            set: function (value) {
               if (_editMode === value) {
                  return;
               }
               _editMode = value;
               onEditableChange();
            }
         },
         /**
          *  @public
          *  @memberof tscrl.TextCalloutSceneViewObject
          *  @property {Boolean} isEditing - enable or disable the edit ui
          */
         isEditing: {
            get: function () {
               return _isEditing;
            },
            set: function (value) {
               if (_isEditing === value) {
                  return;
               }
               _isEditing = value;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.TextCalloutSceneViewObject
          *  @property {string} themeTag - themeTag for this SceneViewObject
          */
         themeTag: {
            get: function () {
               return _themeTag;
            }
         }
      });

      /**
       *  Add event listener to this view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.TextCalloutSceneViewObject
       *  @listens tscrl.TextCalloutSceneViewObject#themeTagModelChange
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to this view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.TextCalloutSceneViewObject
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Remove internal events
       *  @function destroy
       *  @memberof tscrl.TextCalloutSceneViewObject
       */
      _public.destroy = function () {
         unbindEvents();
      };

      bindEvents();
      _public.title = themeableItem.def.text;
      onEditableChange();

      // start applying themes
      onUpdateTheme();

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new TextCalloutSceneViewObject that renders text in a scene
       *  @function create
       *  @param {Object} sceneViewParent - tscrl.SceneView parent for this SceneViewObject
       *  @param {Object} themeableItem - tscml.Scene.themeables array item this object will render
       *  @memberof tscrl.TextCalloutSceneViewObject
       *  @static
       *  @return {Object} new TextCalloutSceneViewObject based on the themeableItem object passed in
       */
      create: function (sceneViewParent, themeableItem) {
         return new TextCalloutSceneViewObject(sceneViewParent, themeableItem);
      }
   };
});

(function (window, backgroundSceneViewObjectFactory) {
   "use strict";
   var namespace = window.tscrl = window.tscrl || {};
   namespace.BackgroundSceneViewObject = backgroundSceneViewObjectFactory(window, namespace.EventDispatcher, namespace.ThemeWrapper, namespace.VideoView, namespace.UriBuilder);
})(this, function (window, EventDispatcher, ThemeWrapper, VideoView, UriBuilder) {

   "use strict";

   /**
    * Theme tag model change event .
    * @event tscrl.BackgroundSceneViewObject#themeTagModelChange
    * @type {object}
    * @property {Object} eventData - Data info passed with event.
    * @property {String} eventData.type - Event name
    * @property {String} eventData.themeTag - Theme tag changed
    * @property {String} eventData.defProperty - Def property changed
    * @property {String} eventData.value - Changed value for the def property.
    */

   /**
    *  @memberof tscrl
    *  @class BackgroundSceneViewObject
    *  @param {tscrl.ThemeableSceneView} sceneViewParent - SceneView parent for this SceneViewObject
    *  @param {Object} themeableItem - tscml.Scene.themeables array item this object will render
    *  @fires tscrl.BackgroundSceneViewObject#themeTagModelChange
    */
   var BackgroundSceneViewObject = function (sceneViewParent, themeableItem) {
      var _public,
         _rootElement,
         _viewElement,
         _eventDispatcher,
         _sceneViewParent,
         _themeWrapper,
         _themeTag,
         _videoView;

      _eventDispatcher = EventDispatcher.create();
      _sceneViewParent = sceneViewParent;
      _themeWrapper = _sceneViewParent.sceneTrackView.projectView.themeWrapper;
      _themeTag = themeableItem.themeTag;

      _rootElement = window.document.createElement("div");
      _rootElement.style.position = "absolute";
      var style = _rootElement.style;
      style.left = "0";
      style.right = "0";
      style.top = "0";
      style.bottom = "0";

      var onUpdateTheme = function (eventData) {
         var themeTagObj = _themeWrapper.getThemeForTag(_themeTag);
         if (themeTagObj) {
            applyTheme(themeTagObj);
         }
      };

      var bindEvents = function () {
         _themeWrapper.on(ThemeWrapper.events.THEME_UPDATED, onUpdateTheme);
      };

      var unbindEvents = function () {
         _themeWrapper.off(ThemeWrapper.events.THEME_UPDATED, onUpdateTheme);
      };

      var applyTheme = function (themeTagObj) {
         if (typeof _videoView === "undefined") {
            var params = {
               source: {
                  duration: _sceneViewParent.duration,
                  uri: themeTagObj.resource.uri
               },
               viewClassName: "text-callout-view"
            };
            _videoView = VideoView.create(UriBuilder.create(), params);
            _viewElement = _videoView.element;
            _rootElement.appendChild(_viewElement);

            var videoStyle = _viewElement.style;
            videoStyle.width = "100%";
            videoStyle.height = "100%";
            videoStyle.left = "0";
            videoStyle.right = "0";
            videoStyle.top = "0";
            videoStyle.bottom = "0";

            sceneViewParent.on("play", function () {
               _videoView.play();
            });

            sceneViewParent.on("pause", function () {
               _videoView.pause();
            });

            sceneViewParent.on("seeked", function (eventData) {
               if (typeof _videoView !== "undefined") {
                  _videoView.seekToTime(eventData.sceneView.currentTime);
                  if(sceneViewParent.paused) {
                     _videoView.pause();
                  } else {
                     _videoView.play();
                  }
               }
            });

            sceneViewParent.on("ended", function () {
               _videoView.pause();
            });
         } else {
            _videoView.src = themeTagObj.resource.uri;
         }

      };

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.BackgroundSceneViewObject
          *  @property {Object} element - Root dom element for this SceneViewObject.
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.BackgroundSceneViewObject
          *  @property {Boolean} editMode - Show edit view of object.
          */
         editMode: {
            get: function () {
               return false;
            },
            set: function (value) {
               // noop
            }
         },
         /**
          *  @public
          *  @memberof tscrl.BackgroundSceneViewObject
          *  @property {string} themeTag - themeTag for this SceneViewObject
          */
         themeTag: {
            get: function () {
               return _themeTag;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.BackgroundSceneViewObject
          *  @property {Number} playbackRate - Playback rate for the scene view object
          */
         playbackRate: {
            get: function() {
              return  _videoView.playbackRate;
            },
            set: function(value) {
               _videoView.playbackRate = value;
            }
         }
      });

      /**
       *  Add event listener to this view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.BackgroundSceneViewObject
       *  @listens tscrl.BackgroundSceneViewObject#themeTagModelChange
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to this view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.BackgroundSceneViewObject
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Remove internal events
       *  @function destroy
       *  @memberof tscrl.BackgroundSceneViewObject
       */
      _public.destroy = function () {
         unbindEvents();
      };

      bindEvents();

      // start applying themes
      onUpdateTheme();

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new TitleLableSceneViewObject that renders Title text in a scene
       *  @function create
       *  @param {Object} sceneViewParent - tscrl.SceneView parent for this SceneViewObject
       *  @param {Object} themeableItem - tscml.Scene.themeables array item this object will render
       *  @memberof tscrl.TitleSceneViewObject
       *  @static
       *  @return {Object} new TitleSceneViewObject based on the themeableItem object passed in
       */
      create: function (sceneViewParent, themeableItem) {
         return new BackgroundSceneViewObject(sceneViewParent, themeableItem);
      }
   };
});

(function (window, sceneViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.SceneView = sceneViewFactory(
      window,
      window.Q,
      window.tscml.sceneType,
      namespace.transformProvider,
      namespace.EmptySourceView,
      namespace.EventDispatcher,
      namespace.constants,
      namespace.TextCalloutSceneViewObject,
      namespace.BackgroundSceneViewObject,
      namespace.AudioNarrationView);
})(this, function (window, Q, sceneType, transformProvider, EmptySourceView, EventDispatcher, constants, TextCalloutSceneViewObject, BackgroundSceneViewObject, AudioNarrationView) {
   "use strict";

   /**
    * durationChange event is triggered when source or audio content is changed.
    * @event tscrl.SceneView#durationChange
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.SceneView} currentTarget - Reference to the content scene view.
    */

   /**
    * themeDefPropertyChange event is triggered when theme def property value has changed.
    * @event tscrl.SceneView#themeDefPropertyChange
    * @type {object}
    * @property {String} type - Event name
    * @property {tscml.Scene} scene - Media Lib Scene object.
    * @property {String} themeTag - Theme tag that contains the def.
    * @property {String} defProperty - Definition property value changed.
    * @property {String} value - Changed value.
    */

   /**
    * timeupdate event is triggered when scene time is updated.
    * @event tscrl.SceneView#timeupdate
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * ended event is triggered when scene has ended.
    * @event tscrl.SceneView#ended
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * seeking event is triggered when source can be played
    * @event tscrl.SceneView#canplay
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * seeking event is triggered when source can be played all they way through
    * @event tscrl.SceneView#canplaythrough
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * seeking event is triggered when scene has started seeking.
    * @event tscrl.SceneView#seeking
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * seeked event is triggered when scene has finished seeking.
    * @event tscrl.SceneView#seeked
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * play event sent when the media begins to play (either for the first time, after having been paused, or after ending and then restarting).
    * @event tscrl.SceneView#playing
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * play event is triggered when scene has started to play.
    * @event tscrl.SceneView#play
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   /**
    * pause event is triggered when scene has been paused.
    * @event tscrl.SceneView#pause
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.sceneView} sceneView - Scene view that triggered the event.
    * @property {Object} originalEvent - Original event dispatched from the internal media element.
    */

   var DEFAULT_METADATA = function () {
      return {
         width: 0,
         height: 0
      };
   };

   var _customSourceViewByMimeType = {};
   var _customSceneElementBySceneType = {};

   var getSupportedSourceForScene = function getSupportedSourceForScene(scene, supportedMimeTypes) {
      var source;
      for (var i = 0, numMimeTypes = supportedMimeTypes.length; i < numMimeTypes; i++) {
         if(scene.getSourceByMimeType) {
            source = scene.getSourceByMimeType(supportedMimeTypes[i]);
            if (source !== undefined) {
               return source;
            }
         }
      }
   };

   var getSourceView = function getSourceView(scene, source, uriBuilder) {
      var ViewConstructor;
      if (source === undefined) {
         return EmptySourceView.create({scene: scene, viewClassName: constants.SOURCE_CLASS_NAME});
      } else {
         if (_customSourceViewByMimeType[source.mimeType]) {
            ViewConstructor = _customSourceViewByMimeType[source.mimeType];
         } else {
            throw new Error("SceneView.create: no view was found to handle a mimeType of (" + source.mimeType + ").");
         }
         return new ViewConstructor(uriBuilder, {scene: scene, source: source, viewClassName: constants.SOURCE_CLASS_NAME});
      }
   };

   var applySceneViewStyles = function (sceneView) {
      sceneView.element.style.height = transformProvider.canvasRect.height + "px";
      sceneView.element.style.width = transformProvider.canvasRect.width + "px";
      sceneView.element.style["transform-origin"] = "0% 0%";
      sceneView.element.style["-ms-transform-origin"] = "0% 0%";
      sceneView.element.style["-webkit-transform-origin"] = "0% 0%";
      sceneView.element.style.position = "absolute";
   };

   /**
    * @memberof tscrl
    * @class SceneView
    * @param {Object} sceneTrackView - The parent tscrl.SceneTrackView for this scene
    * @param {Object} scene - MediaLib scene object.
    * @param {Object} supportedMimeTypes - allowed mime types for sources under this scene view.
    * @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
    * @fires tscrl.SceneView#durationChange
    * @fires tscrl.SceneView#themeDefPropertyChange
    * @fires tscrl.SceneView#timeupdate
    * @fires tscrl.SceneView#canplay
    * @fires tscrl.SceneView#canplaythough
    * @fires tscrl.SceneView#ended
    * @fires tscrl.SceneView#seeking
    * @fires tscrl.SceneView#seeked
    * @fires tscrl.SceneView#playing
    * @fires tscrl.SceneView#play
    * @fires tscrl.SceneView#pause
    */
   var SceneView = function(sceneTrackView, scene, supportedMimeTypes, uriBuilder) {
      var _rootElement;
      var _audioNarrationView;
      var _sourceView;
      var _currentTime;
      var _volume;
      var _boundMediaElement;
      var _sceneViewObjects;
      var _sourceViewMetadata;
      var _eventDispatcher;
      var _sceneViewObjectFactoryMap;
      var _audioNarrationViewOutOfDate;
      var _customSceneView;
      var _isEditMode;
      var _playbackRate;
      var _public;

      _currentTime = 0;
      _volume = constants.DEFAULT_VOLUME;
      _sourceViewMetadata = DEFAULT_METADATA();
      _audioNarrationViewOutOfDate = false;
      _isEditMode = false;
      _playbackRate = constants.DEFAULT_PLAYBACK_RATE;
      _sceneViewObjects = [];
      _eventDispatcher = EventDispatcher.create();
      _rootElement = window.document.createElement("div");
      _rootElement.className = constants.SCENE_CLASS_NAME;
      _boundMediaElement = null;
      _sceneViewObjectFactoryMap = {
         "Title": TextCalloutSceneViewObject,
         "Subtitle": TextCalloutSceneViewObject,
         "Background": BackgroundSceneViewObject
      };

      var onCustomView = function() {
         if(_customSceneView) {
            _rootElement.removeChild(_customSceneView.element);
            _customSceneView.destroy();
            _customSceneView = null;
         }
         if(_customSceneElementBySceneType[scene.type]) {
            var customViewConstructor = _customSceneElementBySceneType[scene.type];
            _customSceneView = customViewConstructor(scene);
            _rootElement.appendChild(_customSceneView.element);
         }
      };

      var destroy = function(removeResizeListener) {
         removeAudioNarrationViewIfExist();
         unbindThemeChangeEvents();
         destroySourceView();
         if(removeResizeListener === true) {
            unbindResizeListener();
         }
         unbindSceneEvents();
         _sceneViewObjects.forEach(function (sceneViewObject) {
            sceneViewObject.destroy();
            _rootElement.removeChild(sceneViewObject.element);
         });
         _sceneViewObjects = [];
      };

      var onSceneTypeChange = function(e) {
         destroy(false);
         _currentTime = 0;
         onSourceChange();
         createThemeableObjectViews();
         bindSceneEvents();
         bindThemeChangeEvents();
         onAudioNarrationChange();
         onCustomView();
      };

      var onMediaEvent = function onMediaEvent(event) {
         switch(event.type) {
            case "timeupdate":
               _currentTime = event.currentTarget.currentTime;
               break;
            case "ended":
               if(_audioNarrationViewOutOfDate) {
                  onAudioNarrationChange();
               }
               break;
            default:
               break;
         }

         _eventDispatcher.trigger(event.type, {sceneView: _public, originalEvent: event});
      };

      var stretchSourceToContainer = function () {
         if (_sourceViewMetadata.width <= 0 || _sourceViewMetadata.height <= 0) {
            return;
         }
         var sourceAspect = _sourceViewMetadata.width / _sourceViewMetadata.height,
            sceneAspect = _rootElement.offsetWidth / _rootElement.offsetHeight,
            sourceElement = _sourceView.element;
         if (sceneAspect <= sourceAspect) {
            sourceElement.style.width = '100%';
            sourceElement.style.height = 'auto';
         } else {
            sourceElement.style.height = '100%';
            sourceElement.style.width = 'auto';
         }
      };

      var handleSourceMetadata = function (sourceView) {
         var metadataReady = sourceView.metadataReady;
         var readyPromise;
         if(typeof metadataReady !== 'undefined' && typeof metadataReady.then === 'function') {
            readyPromise = metadataReady;
         } else {
            readyPromise = Q(DEFAULT_METADATA());
         }

         readyPromise.then(function (metadata) {
            if (typeof metadata === 'undefined' || typeof metadata.width === 'undefined' || typeof metadata.height === 'undefined') {
               return;
            }
            _sourceViewMetadata = metadata;
            stretchSourceToContainer();
            unbindMediaEvents();
            bindMediaEvents();
         });
      };

      var destroySourceView = function() {
         if (_sourceView) {
            unbindMediaEvents();
            if(_sourceView.element.parentNode === _rootElement) {
               _rootElement.removeChild(_sourceView.element);
            }
            _sourceView = undefined;
         }
      };

      var attachSourceView = function (source) {
         destroySourceView();
         _sourceView = getSourceView(scene, source, uriBuilder);
         _sourceView.volume = _volume;
         _sourceView.ready.then(function () {
            handleSourceMetadata(_sourceView);
            bindResizeListener();
            _rootElement.appendChild(_sourceView.element);
         });
      };

      var bindResizeListener = function bindResizeListener() {
         window.tscrl.addResizeListener(_rootElement, stretchSourceToContainer);
      };

      var unbindResizeListener = function bindSourceEvents() {
         window.tscrl.removeResizeListener(_rootElement, stretchSourceToContainer);
      };

      var bindMediaEvents = function() {
         var sourceIsImageAndAudioNarrationElementExists = (_sourceView.type === constants.SOURCE_VIEW_TYPE.IMAGE && _audioNarrationView.element !== null);

         if(_audioNarrationView.duration > _sourceView.duration || sourceIsImageAndAudioNarrationElementExists) {
            _boundMediaElement = _audioNarrationView.element;
            _audioNarrationView.loopOnPlay = true;
            _sourceView.loopOnPlay = false;
            _audioNarrationView.on("mediaRestarted", onMediaRestartEvent);
         } else {
            _boundMediaElement = _sourceView.element;
            _sourceView.loopOnPlay = true;
            _audioNarrationView.loopOnPlay = false;
            _sourceView.on("mediaRestarted", onMediaRestartEvent);
         }
         constants.MEDIA_EVENTS.forEach(function (eventName) {
            _boundMediaElement.addEventListener(eventName, onMediaEvent);
         });
      };

      var unbindMediaEvents = function() {
         _sourceView.off("mediaRestart", onMediaRestartEvent);
         _audioNarrationView.off("mediaRestart", onMediaRestartEvent);

         constants.MEDIA_EVENTS.forEach(function (eventName) {
            _sourceView.element.removeEventListener(eventName, onMediaEvent);
            if(_audioNarrationView && _audioNarrationView.element !== null) {
               _audioNarrationView.element.removeEventListener(eventName, onMediaEvent);
            }
         });
      };

      var bindSceneEvents = function() {
         scene.on("sourceAdded", onSourceChange);
         scene.on("sourceRemoved", onSourceChange);
         scene.on("audioNarrationChange", onAudioNarrationChange);
         scene.on("audioNarrationRemoved", onAudioNarrationChange);
         scene.on("sceneTypeChange", onSceneTypeChange);
      };

      var unbindSceneEvents = function() {
         scene.off("sourceAdded", onSourceChange);
         scene.off("sourceRemoved", onSourceChange);
         scene.off("audioNarrationChange", onAudioNarrationChange);
         scene.off("audioNarrationRemoved", onAudioNarrationChange);
         scene.off("sceneTypeChange", onSceneTypeChange);
      };

      var onMediaRestartEvent = function(e) {
         if(e.currentTarget.type === constants.SOURCE_VIEW_TYPE.AUDIO) {
            _sourceView.seekToTime(0);
            _sourceView.play();
         } else {
            _audioNarrationView.seekToTime(0);
            _audioNarrationView.play();
         }
      };

      var removeAudioNarrationViewIfExist = function() {
         if(!_audioNarrationView || _audioNarrationView.element === null) {
            return;
         }

         unbindMediaEvents();
         _sourceView.volume = _volume;
         _rootElement.removeChild(_audioNarrationView.element);
         _audioNarrationView = AudioNarrationView.create();
      };

      var delayAudioNarrationViewChange = function() {
         return _audioNarrationView && _audioNarrationView.element !== null && _boundMediaElement && !_boundMediaElement.paused;
      };

      var onAudioNarrationChange = function () {
         if(delayAudioNarrationViewChange()) {
            _audioNarrationViewOutOfDate = true;
            return;
         }

         removeAudioNarrationViewIfExist();

         _audioNarrationView = AudioNarrationView.create(scene.audioNarration, uriBuilder);
         _audioNarrationView.volume = _volume;
         _audioNarrationView.ready.then(function(){
            if (_audioNarrationView.element !== null) {
               _rootElement.appendChild(_audioNarrationView.element);
               _sourceView.volume = 0.0;
            }
            return _audioNarrationView.metadataReady.then(function() {
               unbindMediaEvents();
               bindMediaEvents();
               _audioNarrationView.seekToTime(_currentTime);
               _eventDispatcher.trigger("durationChange", {currentTarget:_public});
            }).catch(function() {
               removeAudioNarrationViewIfExist();
               _audioNarrationView = AudioNarrationView.create();
               unbindMediaEvents();
               bindMediaEvents();
               _eventDispatcher.trigger("durationChange", {currentTarget:_public});
            }).finally(function() {
               _audioNarrationViewOutOfDate = false;
            });
         });
      };

      var onSourceChange = function () {
         var source = getSupportedSourceForScene(scene, supportedMimeTypes);
         attachSourceView(source);
         _eventDispatcher.trigger("durationChange", {currentTarget:_public});
      };

      var setPlaybackRate = function() {
         _sceneViewObjects.forEach(function(viewObject) {
            if(viewObject.playbackRate !== undefined) {
               viewObject.playbackRate = _playbackRate;
            }
         });
         _audioNarrationView.playbackRate = _playbackRate;
         _sourceView.playbackRate = _playbackRate;
      };

      var createThemeableObjectViews = function() {
         var themeableObj;
         var sceneViewObjFactory;
         var themeTagSuffix;

         if(!scene.themeables) {
            return;
         }

         for (var i = 0; i < scene.themeables.length; i++) {
            themeableObj = scene.themeables[i];
            themeTagSuffix = themeableObj.themeTag.replace(scene.type, "");

            sceneViewObjFactory = _sceneViewObjectFactoryMap[themeTagSuffix];
            if (sceneViewObjFactory) {
               var sceneViewObj = sceneViewObjFactory.create(_public, themeableObj);
               _public.addSceneViewObject(sceneViewObj);
            }
         }
      };

      var bindThemeChangeEvents = function () {
         _sceneViewObjects.forEach(function (sceneViewObject) {
            sceneViewObject.on("themeTagModelChange", onThemeObjModelChange);
         });
      };

      var unbindThemeChangeEvents = function () {
         _sceneViewObjects.forEach(function (sceneViewObject) {
            sceneViewObject.off("themeTagModelChange", onThemeObjModelChange);
         });
      };

      var onThemeObjModelChange = function (e) {
         var eventData = {
            scene: scene,
            themeTag: e.themeTag,
            defProperty: e.defProperty,
            value: e.value
         };
         _eventDispatcher.trigger("themeDefPropertyChange", eventData);
      };

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Object} element - Dom element for scene.
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Object} mediaElement - Dom element for scene source.
          */
         mediaElement: {
            get: function () {
               return _boundMediaElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Number} currentTime - current time of the scene view.
          */
         currentTime: {
            get: function() {
               return _currentTime;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneView
          *  @property {Number} playbackRate - Playback rate for Scene View.
          */
         playbackRate: {
            get: function() {
               return _playbackRate;
            },
            set: function(value) {
               _playbackRate = value;
               setPlaybackRate();
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Number} duration - Duration of content view.
          */
         duration: {
            get: function () {
               return scene.duration;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Object} sourceView - Source view of content scene
          */
         sourceView: {
            get: function() {
               return _sourceView;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Object} ready - Q Promise that resolves when view is ready.
          */
         ready: {
            get: function () {
               return Q.all([_sourceView.ready, _audioNarrationView.ready]);
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Object} metadataReady - Q Promise that resolves when view metadata is available.
          */
         metadataReady: {
            get: function () {
               return Q.all([_sourceView.metadataReady, _audioNarrationView.metadataReady]);
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Boolean} canPlay - View can be played, for images this will aways be true.
          */
         canPlay: {
            get: function () {
               return _sourceView.canPlay;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {String} sceneType - The type of scene.
          */
         sceneType: {
            get: function () {
               return scene.type;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {tscrl.SceneTrackView} sceneTrackView - the Scene Track View that contains the scene view.
          */
         sceneTrackView: {
            get: function () {
               return sceneTrackView;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Boolean} isScalable - Whether or not this view should be scaled
          */
         isScalable: {
            get: function () {
               return scene.type === sceneType.INTRO || scene.type === sceneType.OUTRO || scene.type === sceneType.TITLE || _sourceView.isScalable;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Boolean} ended - Scene track is ended.
          */
         ended: {
            get: function() {
               return _boundMediaElement === null ? true : _boundMediaElement.ended;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneView
          *  @property {Number} volume - Volume for scene view.
          */
         volume: {
            get: function() {
               return _volume;
            },
            set: function(value) {
               _volume = value;
               _audioNarrationView.volume = _volume;
               if(_audioNarrationView.element === null) {
                  _sourceView.volume = _volume;
               }
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneView
          *  @property {Boolean} paused - Is scene paused.
          */
         paused: {
            get: function() {
               return _boundMediaElement === null ? false : _boundMediaElement.paused;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneView
          *  @property {Boolean} availableToPreview - is scene available to preview.
          */
         availableToPreview: {
            get: function() {
               return ((scene.type === sceneType.CONTENT && scene.sources.length > 0)) || scene.type === sceneType.INTRO || scene.type === sceneType.OUTRO || scene.type === sceneType.TITLE;
            }
         }
      });

      /**
       *  Set if a themeable scene should be in edit mode.
       *  @function setEditMode
       *  @param {Boolean} isEditMode - Edit mode state.
       *  @memberof tscrl.SceneView
       */
      _public.setEditMode = function setEditMode(isEditMode) {
         _isEditMode = isEditMode;
         _sceneViewObjects.forEach(function (sceneViewObj) {
            sceneViewObj.editMode = isEditMode;
         });
      };

      /**
       *  Add a scene view object to the scene
       *  @function addSceneViewObject
       *  @param {Object} sceneViewObj - the scene view object.
       *  @memberof tscrl.SceneView
       */
      _public.addSceneViewObject = function addSceneViewObject(sceneViewObj) {
         _sceneViewObjects.push(sceneViewObj);
         _rootElement.appendChild(sceneViewObj.element);
         sceneViewObj.editMode = _isEditMode;
      };

      /**
       *  Play scene media.
       *  @function play.
       *  @memberof tscrl.SceneView
       */
      _public.play = function play() {
         _audioNarrationView.play();
         _sourceView.play();
      };

      /**
       *  Pause scene media.
       *  @function pause.
       *  @memberof tscrl.SceneView
       */
      _public.pause = function pause() {
         _audioNarrationView.pause();
         _sourceView.pause();
      };

      /**
       *  Manually seek to a given time of the scene
       *  @function seekToTime.
       *  @memberof tscrl.SceneView
       */
      _public.seekToTime = function (time) {
         _audioNarrationView.seekToTime(time);
         _sourceView.seekToTime(time);
      };

      /**
       *  Check a time to see if it can be seeked to.
       *  @function canSeekToTime.
       *  @memberof tscrl.SceneView
       *  @param {Number} seekToTime - time to check.
       *  @return {Boolean} true if can seek to that time.
       */
      _public.canSeekToTime = function(seekToTime) {
         if(_boundMediaElement !== null) {
            for (var i = 0; i < _boundMediaElement.seekable.length; i++) {
               var minSeekTime = _boundMediaElement.seekable.start(i);
               var maxSeekTime = _boundMediaElement.seekable.end(i);
               if (seekToTime >= minSeekTime && seekToTime <= maxSeekTime) {
                  return true;
               }
            }
         }
         return false;
      };

      /**
       *  Add event listener to this view.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.SceneView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to this view.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.SceneView
       */
      _public.off = _eventDispatcher.off;

      /**
       *  Remove internal events
       *  @function destroy
       *  @memberof tscrl.SceneView
       */
      _public.destroy = function () {
         destroy(true);
      };

      onSourceChange();
      createThemeableObjectViews();
      bindSceneEvents();
      bindThemeChangeEvents();
      onAudioNarrationChange();
      onCustomView();

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SceneView object to be displayed.
       *  @function create
       *  @param {Object} sceneTrackView - The parent tscrl.SceneTrackView for this scene
       *  @param {Object} scene - MediaLib scene object.
       *  @param {Object} supportedMimeTypes - allowed mime types for sources under this scene view.
       *  @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
       *  @memberof tscrl.SceneView
       *  @static
       *  @return {Object} Scene View.
       */
      create: function (sceneTrackView, scene, supportedMimeTypes, uriBuilder) {
         var sceneView = new SceneView(sceneTrackView, scene, supportedMimeTypes, uriBuilder);

         applySceneViewStyles(sceneView);

         return sceneView;
      },
      /**
       *  Register custom view for a specific mimeType.
       *  @function registerSourceViewForMimeTypes
       *  @param {Function} ViewConstructor - Custom View constructor.
       *  @param {Array<String>} mimeTypeList - List of mime types. You can override the view for a scene with no sources by specifying the mimetype `techsmith/emptysource`
       *  @memberof tscrl.SceneView
       *  @static
       */
      registerSourceViewForMimeTypes: function (ViewConstructor, mimeTypeList) {
         if (typeof ViewConstructor !== "function") {
            throw new Error("SceneView.registerSourceViewForMimeTypes: viewConstructor must be a function.");
         } else if (Object.prototype.toString.call(mimeTypeList) !== '[object Array]') {
            throw new Error("SceneView.registerSourceViewForMimeTypes: mimeTypeList must be an array of strings.");
         }
         mimeTypeList.forEach(function (mimeType) {
            _customSourceViewByMimeType[mimeType] = ViewConstructor;
         });
      },
      /**
       *  Register custom element for a specific scene type.
       *  @function registerCustomElementForSceneType
       *  @param {Function} ElementConstructor - Custom Element constructor.
       *  @param {String} sceneType - Scene type
       *  @memberof tscrl.SceneView
       *  @static
       */
      registerCustomElementForSceneType: function(ElementConstructor, sceneType) {
         if (typeof ElementConstructor !== "function") {
            throw new Error("SceneView.registerCustomElementForSceneType: ElementConstructor must be a function.");
         }
         _customSceneElementBySceneType[sceneType] = ElementConstructor;
      }
   };
});

(function (window, sceneTrackViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.SceneTrackView = sceneTrackViewFactory(window, window.Q, namespace.EventDispatcher, namespace.MediaListTimeRanges, namespace.SceneView, namespace.constants);

})(this, function (window, Q, EventDispatcher, MediaListTimeRanges, SceneView, constants) {

   "use strict";

   /**
    * Scene Change event fires when scene changes.
    * @event tscrl.SceneTrackView#sceneChange
    * @type {object}
    * @property {String} type - Event name
    * @property {Number} previousSceneIndex - Previous scene index.
    * @property {Number} currentSceneIndex - Current scene index.
    */

   /**
    * Timeupdate event fires when a media element timeupdate fires.
    * @event tscrl.SceneTrackView#timeupdate
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.SceneTrackView} currentTarget - Reference to the scene track view.
    */

   /**
    * Ended event fires when a media element ended fires.
    * @event tscrl.SceneTrackView#ended
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.SceneTrackView} currentTarget - Reference to the scene track view.
    */

   /**
    * Loadedmetadata event is triggered when all initial scene views metadata is available.
    * @event tscrl.SceneTrackView#loadedmetadata
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.SceneTrackView} currentTarget - Previous scene index.
    */

   /**
    * Ready event fires when all scene view media elements are ready.
    * @event tscrl.SceneTrackView#ready
    * @type {object}
    * @property {String} type - Event name
    */

   /**
    * Error event fires an error occurs when creating scene views.
    * @event tscrl.SceneTrackView#error
    * @type {object}
    * @property {String} type - Event name
    * @property {Error} error - Error dispatched.
    */

   /**
    * Datachange event fires when the current scene view media is waiting or resuming from data.
    * @event tscrl.SceneTrackView#datachange
    * @type {object}
    * @property {String} type - Event name
    * @property {tscrl.SceneTrackView} currentTarget - Reference to the scene track view.
    */

   /**
    * Theme tag def property value changed.
    * @event tscrl.SceneTrackView#themeDefPropertyChange
    * @type {object}
    * @property {Object} eventData - Data info passed with event.
    * @property {String} eventData.type - Event name
    * @property {tscml.Scene} eventData.scene - Scene with changed theme tag def property.
    * @property {String} eventData.themeTag - Theme tag changed
    * @property {String} eventData.defProperty - Def property changed
    * @property {String} eventData.value - Changed value for the def property.
    */

   /**
    * Scene View duration has changed.
    * @event tscrl.SceneTrackView#currentSceneViewDurationChange
    * @type {object}
    * @property {Object} eventData - Data info passed with event.
    * @property {String} eventData.type - Event name
    * @property {tscrl.SceneView} eventData.sceneView - Scene view that has duration change.
    */

   /**
    * @memberof tscrl
    * @class SceneTrackView
    * @param {Object} projectView - the parent tscrl.ProjectView
    * @param {Array.<String>} supportedMimeTypes - Array of supported mime types by playback element.
    * @param {tscrl.UriBuilder} uriBuilder - UriBuilder object.
    * @classdesc Scene Track view element.
    * @fires tscrl.SceneTrackView#ready
    * @fires tscrl.SceneTrackView#loadedmetadata
    * @fires tscrl.SceneTrackView#error
    * @fires tscrl.SceneTrackView#sceneChange
    * @fires tscrl.SceneTrackView#timeupdate
    * @fires tscrl.SceneTrackView#ended
    * @fires tscrl.SceneTrackView#datachange
    * @fires tscrl.SceneTrackView#themeDefPropertyChange
    * @fires tscrl.SceneTrackView#currentSceneViewDurationChange
    */
   var SceneTrackView = function (projectView, supportedMimeTypes, uriBuilder) {
      var _sceneTrack,
         _paused,
         _sceneViews,
         _rootElement,
         _currentSceneView,
         _currentSceneIndex,
         _currentTrackTime,
         _currentSceneTime,
         _playbackRate,
         _eventDispatcher,
         _sceneTrackViewPreviewDuration,
         _waitingForData,
         _bufferedMediaListTimeRanges,
         _seekableMediaListTimeRanges,
         _seamlessScenePlayback,
         _activeViewClassName,
         _volume,
         _public,
         _projectView,
         _processingSceneTrackEvent,
         _sceneTrackEventQueue;

      _processingSceneTrackEvent = false;
      _sceneTrackEventQueue = [];
      _projectView = projectView;
      _playbackRate = constants.DEFAULT_PLAYBACK_RATE;
      _paused = true;
      _sceneViews = [];
      _waitingForData = false;
      _eventDispatcher = EventDispatcher.create();
      _sceneTrackViewPreviewDuration = 0;
      _seamlessScenePlayback = true;
      _activeViewClassName = "tscrl-active-view";
      _volume = constants.DEFAULT_VOLUME;

      _rootElement = window.document.createElement("div");
      _rootElement.className = "tscrl-scene-track-view";
      _rootElement.style.height = "100%";
      _rootElement.style.width = "100%";
      _rootElement.style.overflow = "hidden";

      _bufferedMediaListTimeRanges = MediaListTimeRanges.create([], "buffered");
      _seekableMediaListTimeRanges = MediaListTimeRanges.create([], "seekable");

      var removeAllPersistentBindings = function () {
         _sceneViews.forEach(function (sceneView) {
            unbindPersistentSceneEvents(sceneView);
         });
      };

      var removeAllElementsOnRoot = function () {
         while (_rootElement.firstChild) {
            _rootElement.removeChild(_rootElement.firstChild);
         }
      };

      var deactivateScene = function (sceneView) {
         sceneView.pause();
         unbindSceneEvents(sceneView);
         sceneView.element.classList.remove(_activeViewClassName);
      };

      var activateScene = function (sceneView) {
         sceneView.element.classList.add(_activeViewClassName);
         unbindSceneEvents(sceneView);
         bindSceneEvents(sceneView);
      };

      var findNextSceneViewToPreview = function (startIndex) {
         for (var i = startIndex, len=_sceneViews.length; i < len; i++) {
            if (_sceneViews[i].availableToPreview) {
               return i;
            }
         }
         return -1;
      };

      var seekCurrentViewToTime = function (time) {
         if (_currentSceneView && _currentSceneView.canPlay && _currentSceneView.canSeekToTime(time)) {
            _currentSceneTime = time;
            _currentSceneView.seekToTime(time);
            calculateTrackSceneCurrentTime();
         }
      };

      var setCurrentSceneIndex = function (sceneIndex) {
         var lastSceneIndex = _currentSceneIndex;
         _currentSceneIndex = sceneIndex;
         _eventDispatcher.trigger("sceneChange", {previousSceneIndex: lastSceneIndex, currentSceneIndex: sceneIndex});
      };

      var onSceneViewDurationChange = function(e) {
         calculatePreviewSceneTrackDuration();
         if(e.currentTarget === _currentSceneView) {
            _eventDispatcher.trigger("currentSceneViewDurationChange", {sceneView: e.currentTarget});
         }
      };

      var calculatePreviewSceneTrackDuration = function() {
         _sceneTrackViewPreviewDuration = 0;
         _sceneViews.forEach(function(sceneView) {
            if(sceneView.availableToPreview) {
               _sceneTrackViewPreviewDuration += sceneView.duration;
            }
         });
      };

      var displaySceneView = function (sceneIndex, seekTime) {
         if (_currentSceneView && _currentSceneIndex !== undefined && _currentSceneIndex !== sceneIndex) {
            deactivateScene(_currentSceneView);
         }

         _currentSceneView = _sceneViews[sceneIndex];

         if (_currentSceneIndex !== sceneIndex) {
            activateScene(_currentSceneView);
            setCurrentSceneIndex(sceneIndex);
            _currentSceneTime = 0;
         }

         if (seekTime === undefined) {
            seekTime = 0;
         }
         seekCurrentViewToTime(seekTime);

         if (!_paused) {
            _currentSceneView.play();
         }
      };

      var redrawCurrentSceneView = function () {
         _currentSceneView = _sceneViews[_currentSceneIndex];
         activateScene(_currentSceneView);
         setCurrentSceneIndex(_currentSceneIndex);
         _currentSceneTime = 0;
         seekCurrentViewToTime(0);
         if (!_paused) {
            _currentSceneView.play();
         }
      };

      var calculateTrackSceneCurrentTime = function () {
         _currentTrackTime = 0;
         for (var i = 0; i < _currentSceneIndex; i++) {
            if(_seamlessScenePlayback && !_sceneViews[i].availableToPreview) {
               continue;
            }
            _currentTrackTime += _sceneViews[i].duration;
         }
         _currentTrackTime += _currentSceneTime;
      };

      var onMediaTimeUpdate = function (event) {
         _currentSceneTime = _currentSceneView.currentTime;
         calculateTrackSceneCurrentTime();
         _eventDispatcher.trigger("timeupdate", {currentTarget: _public});
      };

      var onMediaEnded = function () {
         if (_seamlessScenePlayback && _currentSceneIndex < _sceneTrack.scenes.length - 1) {
            var nextPreviewSceneIndex = findNextSceneViewToPreview(_currentSceneIndex + 1);
            if (nextPreviewSceneIndex !== -1) {
               displaySceneView((nextPreviewSceneIndex));
            } else {
               _eventDispatcher.trigger("ended", {currentTarget: _public});
            }
         } else {
            _eventDispatcher.trigger("ended", {currentTarget: _public});
         }
      };

      var bufferEventHandling = function (e) {
         if (_public.ended) {
            return;
         }
         switch (e.type) {
            case "stalled":
            case "waiting":
               if (!_waitingForData) {
                  _waitingForData = true;
                  _eventDispatcher.trigger("datachange", {currentTarget: _public});
               }
               break;
            case "playing":
            case "canplay":
            case "canplaythrough":
               if (_waitingForData) {
                  _waitingForData = false;
                  _eventDispatcher.trigger("datachange", {currentTarget: _public});
               }
               break;
         }
         _eventDispatcher.trigger(e.type, {currentTarget: _public});
      };

      var onMediaEvent = function(e) {
         _eventDispatcher.trigger(e.type, {currentTarget: _public, originalEvent: e.originalEvent});
      };

      var onThemeDefPropertyChange = function (e) {
         _eventDispatcher.trigger("themeDefPropertyChange", e);
      };

      var bindSceneEvents = function (sceneView) {
         sceneView.on("stalled", bufferEventHandling);
         sceneView.on("waiting", bufferEventHandling);
         sceneView.on("playing", bufferEventHandling);
         sceneView.on("canplay", bufferEventHandling);
         sceneView.on("canplaythrough", bufferEventHandling);
         sceneView.on("timeupdate", onMediaTimeUpdate);
         sceneView.on("ended", onMediaEnded);
         sceneView.on("seeking", onMediaEvent);
         sceneView.on("seeked", onMediaEvent);
         sceneView.on("play", onMediaEvent);
         sceneView.on("pause", onMediaEvent);
      };

      var unbindSceneEvents = function (sceneView) {
         sceneView.off("stalled", bufferEventHandling);
         sceneView.off("waiting", bufferEventHandling);
         sceneView.off("playing", bufferEventHandling);
         sceneView.off("canplay", bufferEventHandling);
         sceneView.off("canplaythrough", bufferEventHandling);
         sceneView.off("timeupdate", onMediaTimeUpdate);
         sceneView.off("ended", onMediaEnded);
         sceneView.off("seeking", onMediaEvent);
         sceneView.off("seeked", onMediaEvent);
         sceneView.off("play", onMediaEvent);
         sceneView.off("pause", onMediaEvent);
      };

      var bindPersistentSceneEvents = function (sceneView) {
         sceneView.on("themeDefPropertyChange", onThemeDefPropertyChange);
         sceneView.on("durationChange", onSceneViewDurationChange);
      };

      var unbindPersistentSceneEvents = function (sceneView) {
         sceneView.off("themeDefPropertyChange", onThemeDefPropertyChange);
         sceneView.off("durationChange", onSceneViewDurationChange);
      };

      var addSceneViewElementToRoot = function (sceneViewElement, index) {
         var nextIndex;

         if (typeof index === "undefined") {
            index = _sceneViews.length;
         }
         nextIndex = index + 1;
         if (nextIndex >= _sceneViews.length) {
            _rootElement.appendChild(sceneViewElement);
         } else {
            _rootElement.insertBefore(sceneViewElement, _sceneViews[nextIndex].element);
         }
      };

      var addSceneViewToTimeRanges = function (sceneView, index) {
         _bufferedMediaListTimeRanges.addMedia(sceneView, index);
         _seekableMediaListTimeRanges.addMedia(sceneView, index);
      };

      var activateAdjacentSceneViewByIndex = function (index) {
         if (_sceneViews.length <= 1) {
            setCurrentSceneIndex(undefined);
            _currentSceneView = undefined;
            return;
         }
         var adjacentIndex;
         if (index < _sceneViews.length - 1) {
            adjacentIndex = ++index;
         } else {
            adjacentIndex = --index;
         }
         _currentSceneView = _sceneViews[adjacentIndex];
         setCurrentSceneIndex(adjacentIndex);
         activateScene(_currentSceneView);
      };

      var addSceneView = function (scene, index) {
         _processingSceneTrackEvent = true;
         createSceneView(scene, index).then(function () {
            var addedSceneView = _sceneViews[index];
            if (addedSceneView.setEditMode !== undefined) {
               addedSceneView.setEditMode(!_seamlessScenePlayback);
            }
            addSceneViewElementToRoot(addedSceneView.element, index);
            addSceneViewToTimeRanges(addedSceneView, index);
            _processingSceneTrackEvent = false;
            processNextSceneTrackEvent();
            calculatePreviewSceneTrackDuration();
         });
      };

      var removeSceneView = function (scene, index) {
         _processingSceneTrackEvent = true;
         if (_currentSceneIndex === index) {
            deactivateScene(_currentSceneView);
            activateAdjacentSceneViewByIndex(index);
         }

         unbindPersistentSceneEvents(_sceneViews[index]);

         _bufferedMediaListTimeRanges.removeMedia(index);
         _seekableMediaListTimeRanges.removeMedia(index);
         _rootElement.removeChild(_sceneViews[index].element);
         _sceneViews[index].destroy();
         _sceneViews.splice(index, 1);
         if (_currentSceneIndex > index) {
            setCurrentSceneIndex(_currentSceneIndex - 1);
         }
         _processingSceneTrackEvent = false;
         processNextSceneTrackEvent();
         calculatePreviewSceneTrackDuration();
      };

      var moveSceneView = function (fromIndex, toIndex) {
         _processingSceneTrackEvent = true;
         _sceneViews.splice(toIndex, 0, _sceneViews.splice(fromIndex, 1)[0]);
         _bufferedMediaListTimeRanges.moveMedia(fromIndex, toIndex);
         _seekableMediaListTimeRanges.moveMedia(fromIndex, toIndex);
         addSceneViewElementToRoot(_rootElement.removeChild(_sceneViews[toIndex].element), toIndex);
         if (_currentSceneIndex === fromIndex) {
            setCurrentSceneIndex(toIndex);
         }
         _processingSceneTrackEvent = false;
         processNextSceneTrackEvent();
      };

      var createSceneView = function (scene, index) {
         var sceneView = SceneView.create(_public, scene, supportedMimeTypes, uriBuilder);
         if (!isNaN(parseInt(index, 10))) {
            _sceneViews.splice(index, 0, sceneView);
         } else {
            _sceneViews.push(sceneView);
         }
         bindPersistentSceneEvents(sceneView);
         return sceneView.ready;
      };

      var createSceneViews = function () {
         if (_currentSceneView) {
            unbindSceneEvents(_currentSceneView);
            removeAllElementsOnRoot();
            removeAllPersistentBindings();
         }

         var sceneViewReadyPromises = [];

         _sceneViews = [];
         _sceneTrack.scenes.forEach(function (scene) {
            sceneViewReadyPromises.push(createSceneView(scene));
         });

         return Q.all(sceneViewReadyPromises).then(function () {
            var sceneViewMetaDataPromises = [];
            _sceneViews.forEach(function (sceneView) {
               sceneViewMetaDataPromises.push(sceneView.metadataReady);
               addSceneViewElementToRoot(sceneView.element);
               addSceneViewToTimeRanges(sceneView);
               calculatePreviewSceneTrackDuration();
            });
            return Q.all(sceneViewMetaDataPromises).then(function() {
               _eventDispatcher.trigger("loadedmetadata", {currentTarget: _public});
            });
         });
      };

      var seekByTrackTime = function (time) {
         var sceneDuration = 0;
         for (var i = 0, len=_sceneViews.length; i < len; i++) {
            if(_seamlessScenePlayback && !_sceneViews[i].availableToPreview) {
               continue;
            }
            sceneDuration += _sceneViews[i].duration;
            if (time <= sceneDuration) {
               displaySceneView(i, (time - (sceneDuration - _sceneViews[i].duration)));
               break;
            }
         }
      };

      var onSceneTrackEvent = function (event) {
         _sceneTrackEventQueue.push(event);
         processNextSceneTrackEvent();
      };

      var processNextSceneTrackEvent = function () {
         if (_processingSceneTrackEvent) {
            return;
         }
         var event = _sceneTrackEventQueue.pop();
         if (event) {
            switch (event.type) {
               case "sceneAdded":
                  addSceneView(event.scene, event.index);
                  break;
               case "sceneRemoved":
                  removeSceneView(event.scene, event.index);
                  break;
               case "sceneMoved":
                  moveSceneView(event.fromIndex, event.toIndex);
                  break;
               default:
                  break;
            }
         }
      };

      var onSeamlessScenePlaybackChange = function () {
         _sceneViews.forEach(function (sceneView) {
            sceneView.setEditMode(!_seamlessScenePlayback);
         });

         if(_seamlessScenePlayback && _currentSceneView && !_currentSceneView.availableToPreview) {
            var nextIndex = findNextSceneViewToPreview(_currentSceneIndex);
            if(nextIndex !== -1) {
               displaySceneView(nextIndex, 0);
            }
         }
      };

      var setSceneViewsPlaybackRate = function() {
         _sceneViews.forEach(function(sceneView) {
            sceneView.playbackRate = _playbackRate;
         });
      };

      var seekBySceneTime = function (time) {
         if (time < 0) {
            time = 0;
         } else if (time > _currentSceneView.duration) {
            time = _currentSceneView.duration;
         }
         seekCurrentViewToTime(time);
      };

      var needToRestartSceneTrack = function () {
         return _seamlessScenePlayback && _currentSceneView !== undefined && _currentSceneView.ended && findNextSceneViewToPreview(_currentSceneIndex + 1) === -1;
      };

      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {tscml.SceneTrack} src - SceneTrack object.
          */
         src: {
            get: function () {
               return _sceneTrack;
            },
            set: function (value) {
               _sceneTrack = value;
               _sceneTrack.on('sceneAdded', onSceneTrackEvent);
               _sceneTrack.on('sceneRemoved', onSceneTrackEvent);
               _sceneTrack.on('sceneMoved', onSceneTrackEvent);

               createSceneViews().then(function () {
                  if (_sceneViews.length > 0) {
                     onSeamlessScenePlaybackChange();
                     if (_seamlessScenePlayback) {
                        var nextSceneWithDuration = findNextSceneViewToPreview(0);
                        if (nextSceneWithDuration !== -1) {
                           displaySceneView(nextSceneWithDuration);
                        }
                     } else {
                        displaySceneView(0);
                     }
                  }
                  _eventDispatcher.trigger("ready");
               }).catch(function (error) {
                  _eventDispatcher.trigger("error", error);
               });
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} duration - Duration of the scene track view for all scene views that can be previewed.
          */
         duration: {
            get: function () {
               return _seamlessScenePlayback ? _sceneTrackViewPreviewDuration : _sceneTrack.duration;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Array.<tscrl.SceneView>} sceneViews - List of Scene Views.
          */
         sceneViews: {
            get: function () {
               return [].concat(_sceneViews);
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Object} currentSceneView - The current scene view.
          */
         currentSceneView: {
            get: function () {
               return _currentSceneView;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} currentTime - current time of the entire scene track.
          */
         currentTime: {
            get: function () {
               return _currentTrackTime;
            },
            set: function (value) {
               var upperBoundDuration = _sceneTrack.duration;
               if(_seamlessScenePlayback) {
                  upperBoundDuration = _sceneTrackViewPreviewDuration;
               }

               if (value < 0) {
                  seekByTrackTime(0);
               } else if (value > upperBoundDuration) {
                  seekByTrackTime(upperBoundDuration);
               } else {
                  seekByTrackTime(value);
               }
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} playbackRate - Playback rate for the Scene View Track
          */
         playbackRate: {
            get: function() {
               return _playbackRate;
            },
            set: function(value) {
               _playbackRate = value;
               setSceneViewsPlaybackRate();
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Object} projectView - parent tscrl.ProjectView
          */
         projectView: {
            get: function () {
               return _projectView;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Boolean} paused - Scene track is paused.
          */
         paused: {
            get: function () {
               return _paused;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Boolean} ended - Scene track is at the end.
          */
         ended: {
            get: function () {
               return _sceneViews.length === 0 || ((_currentSceneView === _sceneViews[_sceneViews.length - 1]) && _currentSceneView.ended);
            }
         },
         /**
          *  @public
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} currentSceneTime - Current time of the current playing scene.
          */
         currentSceneTime: {
            get: function () {
               return _currentSceneTime;
            },
            set: function (value) {
               seekBySceneTime(value);
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} currentSceneDuration - Duration of the current playing scene.
          *  @deprecated since version 0.17.0
          */
         currentSceneDuration: {
            get: function () {
               return _currentSceneView === undefined ? 0 : _currentSceneView.duration;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} currentSceneIndex - Index of current playing scene.
          */
         currentSceneIndex: {
            get: function () {
               return _currentSceneIndex;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Element} element - View element
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {tscrl.MediaListTimeRanges} buffered - List of buffered TimeRanges for all media elements in the track.
          */
         buffered: {
            get: function () {
               return _bufferedMediaListTimeRanges;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {tscrl.MediaListTimeRanges} seekable - List of seekable TimeRanges for all media elements in the track.
          */
         seekable: {
            get: function () {
               return _seekableMediaListTimeRanges;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Boolean} waitingForData - Is playback waiting for data for the media.
          */
         waitingForData: {
            get: function () {
               return _waitingForData;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Number} volume - Volume value for all media in the scene track.
          */
         volume: {
            get: function () {
               return _volume;
            },
            set: function (value) {
               var valueAsFloat = parseFloat(value);
               if (isNaN(valueAsFloat)) {
                  throw new Error("TypeError: Failed to set the 'volume' property on 'SceneTrackView': The provided double value is non-finite.");
               }
               _volume = valueAsFloat;
               _sceneViews.forEach(function (sceneView) {
                  if(sceneView !== null) {
                     sceneView.volume = valueAsFloat;
                  }
               });
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.SceneTrackView
          *  @property {Boolean} seamlessScenePlayback - Auto advance to next scene after current scene ends.
          */
         seamlessScenePlayback: {
            get: function () {
               return _seamlessScenePlayback;
            },
            set: function (value) {
               if (_seamlessScenePlayback === value) {
                  return;
               }
               _seamlessScenePlayback = value;
               onSeamlessScenePlaybackChange();
            }
         }
      });

      /**
       *  Get a promise that will resolve with the current scene duration.
       *  @function getCurrentSceneDuration
       *  @memberof tscrl.SceneTrackView
       *  @return {Object} Q promise that will resolve with a current scene duration.
       */
      _public.getCurrentSceneDuration = function() {
         if(_currentSceneView === undefined ) {
            return Q(0);
         } else {
            return _currentSceneView.metadataReady.then(function() {
               return _currentSceneView.duration;
            });
         }
      };

      /**
       *  Scales and translates scene views that are scaleable
       *  @function applyTransform
       *  @memberof tscrl.SceneTrackView
       */
      _public.applyTransform = function (scaledTransform, resizedTransform) {
         var scaledTransformCss = "scale(" + scaledTransform.scale + "," + scaledTransform.scale + ") translate(" + scaledTransform.translation.x + "px, " + scaledTransform.translation.y + "px)";
         var resizeTransform = " translate(" + resizedTransform.translation.x + "px, " + resizedTransform.translation.y + "px)";
         _sceneViews.forEach(function (scene) {
            if (scene.isScalable) {
               scene.element.style.transform = scaledTransformCss;
               scene.element.style["-webkit-transform"] = scaledTransformCss;
               scene.element.style["-ms-transform"] = scaledTransformCss;
            } else {
               scene.element.style.width = resizedTransform.size.width + "px";
               scene.element.style.height = resizedTransform.size.height + "px";

               scene.element.style.transform = resizeTransform;
               scene.element.style["-webkit-transform"] = resizeTransform;
               scene.element.style["-ms-transform"] = resizeTransform;
            }
         });
      };

      /**
       *  Play the scene track.
       *  @function play
       *  @memberof tscrl.SceneTrackView
       */
      _public.play = function play() {
         if (needToRestartSceneTrack()) {
            var sceneIndex = findNextSceneViewToPreview(0);
            if (sceneIndex !== -1) {
               displaySceneView(sceneIndex, 0);
            }
         }
         _paused = false;
         if (_currentSceneView) {
            _currentSceneView.play();
            _eventDispatcher.trigger('play', {currentTarget: _public});
         }
      };

      /**
       *  Pause the scene track.
       *  @function pause
       *  @memberof tscrl.SceneTrackView
       */
      _public.pause = function pause() {
         _paused = true;
         if (_currentSceneView) {
            _currentSceneView.pause();
            _eventDispatcher.trigger('pause', {currentTarget: _public});
         }
      };

      /**
       *  Seek to a specific scene by the scene index.  When seamlessScenePlayback is true, the scene at that supplied
       *  index must be available to preview or it will grab the next scene that can be previewed.
       *  @function seekToSceneAtIndex
       *  @param {Number} sceneIndex - Index of scene to play.
       *  @memberof tscrl.SceneTrackView
       */
      _public.seekToSceneAtIndex = function (sceneIndex) {
         if (!_sceneTrack || sceneIndex < 0 || (sceneIndex !== 0 && sceneIndex >= _sceneTrack.scenes.length)) {
            throw new Error("seekToSceneAtIndex: Scene index of " + sceneIndex + " is out bounds.");
         }
         if (_seamlessScenePlayback) {
            var nextSceneWithDuration = findNextSceneViewToPreview(sceneIndex);
            if (nextSceneWithDuration !== -1) {
               displaySceneView(nextSceneWithDuration);
            }
         } else {
            displaySceneView(sceneIndex);
         }
      };

      /**
       *  Redraw the current scene.
       *  @function seekToSceneAtIndex
       *  @memberof tscrl.SceneTrackView
       */
      _public.redrawCurrentScene = redrawCurrentSceneView;

      /**
       *  Add event listener to scene track.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @listens tscrl.SceneTrackView#ready
       *  @listens tscrl.SceneTrackView#error
       *  @listens tscrl.SceneTrackView#sceneChange
       *  @listens tscrl.SceneTrackView#timeupdate
       *  @listens tscrl.SceneTrackView#ended
       *  @listens tscrl.SceneTrackView#datachange
       *  @listens tscrl.SceneTrackView#themeDefPropertyChange
       *  @listens tscrl.SceneTrackView#loadedmetadata
       *  @listens tscrl.SceneView#canplay
       *  @listens tscrl.SceneView#canplaythough
       *  @listens tscrl.SceneView#ended
       *  @listens tscrl.SceneView#seeking
       *  @listens tscrl.SceneView#seeked
       *  @listens tscrl.SceneView#playing
       *  @listens tscrl.SceneView#play
       *  @listens tscrl.SceneView#pause
       *  @memberof tscrl.SceneTrackView
       */
      _public.on = _eventDispatcher.on;

      /**
       *  Remove event listener to scene track.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.SceneTrackView
       */
      _public.off = _eventDispatcher.off;

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new SceneTrackView object.
       *  @function create
       *  @param {Object} projectView - the parent tscrl.ProjectView
       *  @param {Array.<String>} supportedMimeTypes - Array of supported mime types by playback element.
       *  @param {String} basePath - Optional path to load a URI from.
       *  @memberof tscrl.SceneTrackView
       *  @static
       *  @return {tscrl.SceneTrackView} new SceneTrackView instance
       */
      create: function (projectView, supportedMimeTypes, basePath) {
         return new SceneTrackView(projectView, supportedMimeTypes, basePath);
      }
   };
});

(function (window, projectViewFactory) {
   "use strict";

   var namespace = window.tscrl = window.tscrl || {};
   namespace.ProjectView = projectViewFactory(window, namespace.UriBuilder, namespace.SceneTrackView, namespace.EventDispatcher, namespace.ThemeWrapper, namespace.transformProvider);

})(this, function (window, UriBuilder, SceneTrackView, EventDispatcher, ThemeWrapper, transformProvider) {

   "use strict";

   /**
    * @memberof tscrl
    * @class ProjectView
    * @param {Array.<String>} supportedMimeTypes - List of supported mime types.
    * @param {String} basePath - Optional path to load a URI from.
    * @classdesc Project View for a Medialib JS Project
    * @tutorial getting-started
    */
   var ProjectView = function (supportedMimeTypes, basePath) {
      var _rootElement,
         _sceneTrackView,
         _mediaLibProject,
         _uriBuilder,
         _public,
         _themeWrapper,
         _eventDispatcher;

      _themeWrapper = ThemeWrapper.create();
      _eventDispatcher = EventDispatcher.create();


      basePath = basePath || "";
      _uriBuilder = UriBuilder.create();
      _uriBuilder.basePath = basePath;


      _public = Object.defineProperties({}, {
         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {tscml.Project} src - Media Lib Project object.
          */
         src: {
            get: function () {
               return _mediaLibProject;
            },
            set: function (value) {
               _mediaLibProject = value;
               _sceneTrackView.src = _mediaLibProject.timeline.sceneTrack;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Number} duration - Duration of project.
          */
         duration: {
            get: function () {
               return _sceneTrackView.duration;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {Number} currentTime - Current time of the entire project.
          */
         currentTime: {
            get: function () {
               return _sceneTrackView.currentTime;
            },
            set: function (value) {
               _sceneTrackView.currentTime = value;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {Number} playbackRate - Playback rate for entire project.
          */
         playbackRate: {
            get: function() {
               return _sceneTrackView.playbackRate;
            },
            set: function(value) {
               var numValue = parseFloat(value);
               if(isNaN(numValue)) {
                  throw "ProjectView.playbackRate expects a number, but got (" + value + ").";
               }

               if(numValue < 0.25) {
                  numValue = 0.25;
               } else if(numValue > 2) {
                  numValue = 2;
               }

               _sceneTrackView.playbackRate = numValue;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Boolean} paused - Project is paused.
          */
         paused: {
            get: function () {
               return _sceneTrackView.paused;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Boolean} ended - Project is at the end.
          */
         ended: {
            get: function () {
               return _sceneTrackView.ended;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {Number} currentSceneTime - Current time of the current playing scene.
          */
         currentSceneTime: {
            get: function () {
               return _sceneTrackView.currentSceneTime;
            },
            set: function (value) {
               _sceneTrackView.currentSceneTime = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Number} currentSceneDuration - Duration of the current playing scene.
          *  @deprecated since version 0.17.0
          */
         currentSceneDuration: {
            get: function () {
               return _sceneTrackView.currentSceneDuration;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Number} currentSceneIndex - Index of current playing scene.
          */
         currentSceneIndex: {
            get: function () {
               return _sceneTrackView.currentSceneIndex;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Element} element - View element
          */
         element: {
            get: function () {
               return _rootElement;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {tscrl.SceneTrackView} sceneTrackView - Scene Track View
          */
         sceneTrackView: {
            get: function () {
               return _sceneTrackView;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {tscrl.MediaListTimeRanges} buffered - List of buffered elements for all media elements in the track.
          */
         buffered: {
            get: function () {
               return _sceneTrackView.buffered;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {tscrl.MediaListTimeRanges} seekable - List of seekable TimeRanges for the project.
          */
         seekable: {
            get: function () {
               return _sceneTrackView.seekable;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Boolean} waitingForData - Is playback waiting for data for the media.
          */
         waitingForData: {
            get: function () {
               return _sceneTrackView.waitingForData;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Number} volume - Volume for the project.
          */
         volume: {
            get: function () {
               return _sceneTrackView.volume;
            },
            set: function (value) {
               _sceneTrackView.volume = value;
            }
         },
         /**
          *  @public
          *  @readonly
          *  @memberof tscrl.ProjectView
          *  @property {Boolean} seamlessScenePlayback - Auto advance to next scene after current scene ends.
          */
         seamlessScenePlayback: {
            get: function () {
               return _sceneTrackView.seamlessScenePlayback;
            },
            set: function (value) {
               _sceneTrackView.seamlessScenePlayback = value;
            }
         },
         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {Object} theme - The theme that is applied to the entire project..
          */
         theme: {
            get: function () {
               return _themeWrapper.theme;
            },
            set: function (value) {
               _themeWrapper.theme = value;
            }
         },

         /**
          *  @public
          *  @memberof tscrl.ProjectView
          *  @property {Object} themeWrapper - A tscrl.ThemeWrapper object that contains the current theme for this ProjectView and sub-objects
          */
         themeWrapper: {
            get: function () {
               return _themeWrapper;
            }
         }
      });

      _rootElement = document.createElement("div");
      _rootElement.className = "tscrl-project-view";
      _rootElement.style.position = "absolute";
      _rootElement.style.top = 0;
      _rootElement.style.left = 0;
      _rootElement.style.right = 0;
      _rootElement.style.bottom = 0;
      _sceneTrackView = SceneTrackView.create(_public, supportedMimeTypes, _uriBuilder);
      _rootElement.appendChild(_sceneTrackView.element);

      /**
       *  Play the project.
       *  @function play
       *  @memberof tscrl.ProjectView
       */
      _public.play = function play() {
         _sceneTrackView.play();
      };

      /**
       *  Pause the project.
       *  @function pause
       *  @memberof tscrl.ProjectView
       */
      _public.pause = function pause() {
         _sceneTrackView.pause();
      };

      /**
       *  Seek to a specific scene by the scene index.
       *  @function seekToSceneAtIndex
       *  @param {Number} sceneIndex - Index of scene to play.
       *  @memberof tscrl.ProjectView
       */
      _public.seekToSceneAtIndex = function (sceneIndex) {
         _sceneTrackView.seekToSceneAtIndex(sceneIndex);
      };

      /**
       *  Get a promise that will resolve with the current scene duration.
       *  @function getCurrentSceneDuration
       *  @memberof tscrl.ProjectView
       *  @return {Object} Q promise that will resolve with a current scene duration.
       */
      _public.getCurrentSceneDuration = function() {
         return _sceneTrackView.getCurrentSceneDuration();
      };

      /**
       *  Redraw the current scene.
       *  @function seekToSceneAtIndex
       *  @memberof tscrl.ProjectView
       */
      _public.redrawCurrentScene = function (sceneIndex) {
         _sceneTrackView.redrawCurrentScene(sceneIndex);
      };

      /**
       *  Add event listener to scene track.
       *  @function on
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ProjectView
       *  @listens tscrl.SceneTrackView#ready
       *  @listens tscrl.SceneTrackView#error
       *  @listens tscrl.SceneTrackView#sceneChange
       *  @listens tscrl.SceneTrackView#timeupdate
       *  @listens tscrl.SceneTrackView#ended
       *  @listens tscrl.SceneTrackView#datachange
       *  @listens tscrl.SceneTrackView#themeDefPropertyChange
       */
      _public.on = function (eventName, callback) {
         _sceneTrackView.on(eventName, callback);
      };

      /**
       *  Remove event listener to scene track.
       *  @function off
       *  @param {String} eventName - Name of event
       *  @param {Function} callback - Callback when event is triggered.
       *  @memberof tscrl.ProjectView
       */
      _public.off = function (eventName, callback) {
         _sceneTrackView.off(eventName, callback);
      };

      /**
       *  Tell the canvas that it should resize itself
       *  @function canvasNeedsResize
       *  @memberof tscrl.ProjectView
       */
      _public.canvasNeedsResizing = function () {
         window.requestAnimationFrame(transformProjectView);
      };

      var transformProjectView = function () {
         var parent = _rootElement.parentElement;
         var rect = parent.getBoundingClientRect();
         var currentWidth = rect.width;
         var currentHeight = rect.height;
         var canvas = transformProvider.canvasRect;
         var scaleWidth = currentWidth / canvas.width;
         var scaleHeight = currentHeight / canvas.height;
         // choose the lowest of the two since the aspect ratio will always be the same
         // max scale should be the perfect pixel canvas size
         var scale = Math.min(scaleWidth, scaleHeight, 1);
         var translation = {
            x: 0.5 * (currentWidth - (scale * canvas.width)),
            y: 0.5 * (currentHeight - (scale * canvas.height))
         };

         var scaledTraslation = {
            x: translation.x / scale,
            y: translation.y / scale
         };

         var transformScaled = {
            scale: scale,
            translation: scaledTraslation
         };

         var transformResized = {
            size: {
               width: canvas.width * scale,
               height: canvas.height * scale
            },
            translation: translation
         };

         _sceneTrackView.applyTransform(transformScaled, transformResized);
      };

      return _public;
   };

   return {
      /**
       *  Factory method that returns a new ProjectView object.
       *  @function create
       *  @param {Array.<String>} supportedMimeTypes - List of supported mime types.
       *  @param {String} basePath - Optional path to load a URI from.
       *  @memberof tscrl.ProjectView
       *  @static
       *  @return {tscrl.ProjectView} new ProjectView instance.
       */
      create: function (supportedMimeTypes, basePath) {
         return new ProjectView(supportedMimeTypes, basePath);
      }
   };
});

(function (window, defaultSettingsRegistryFactory) {
   "use strict";

   defaultSettingsRegistryFactory(window, window.tscrl.SceneView, window.tscrl.ImageView, window.tscrl.VideoView);
})(this, function (window, SceneView, ImageView, VideoView) {
   "use strict";

   SceneView.registerSourceViewForMimeTypes(ImageView.create, ["image/png", "image/jpg", "image/jpeg", "image/gif"]);
   SceneView.registerSourceViewForMimeTypes(VideoView.create, ["video/mp4"]);
});
